"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4209],{

/***/ 64815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CookieBannerToggleSwitch": function() { return /* binding */ CookieBannerToggleSwitch; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var CookieBannerToggleSwitch = function(param) {
    var id = param.id, name = param.name, checked = param.checked, onChange = param.onChange, _alwaysActive = param.alwaysActive, alwaysActive = _alwaysActive === void 0 ? false : _alwaysActive;
    var handleToggle = function() {
        if (alwaysActive) return; // Prevent toggling if alwaysActive is true
        onChange === null || onChange === void 0 ? void 0 : onChange({
            id: id,
            name: name,
            checked: !checked
        });
    };
    /* Outer association uses <label htmlFor={id}> in CookiesBanner so the option text is a visible label. */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "inline-flex shrink-0 items-center ".concat(alwaysActive ? "cursor-not-allowed pointer-events-none" : "cursor-pointer"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: "checkbox",
                checked: alwaysActive ? true : checked,
                onChange: handleToggle,
                className: "sr-only",
                "aria-checked": alwaysActive ? true : checked,
                disabled: alwaysActive,
                id: id,
                name: name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative w-12 h-6 rounded-full transition-colors duration-200 ease-in-out ".concat(checked ? "bg-primary-600 hover:bg-primary-700 active:bg-primary-800" : "bg-neutral-400 hover:bg-neutral-500 active:bg-neutral-600", " ").concat(alwaysActive ? "opacity-60 bg-neutral-400" : ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute top-1/2 -translate-y-1/2 left-1 w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-200 ease-in-out ".concat(alwaysActive || checked ? "translate-x-6" : "translate-x-0")
                })
            })
        ]
    });
};


/***/ }),

/***/ 27692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CookiesBanner": function() { return /* binding */ CookiesBanner; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16606);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38505);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _CookieBannerToggleSwitch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64815);
/* harmony import */ var components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87664);
/* harmony import */ var components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62009);
/* harmony import */ var components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63651);
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable @typescript-eslint/no-explicit-any */ 












var CookiesBanner = function(param) {
    var AcceptButtonText = param.AcceptButtonText, BannerDescription = param.BannerDescription, BannerTitle = param.BannerTitle, ConfirmOptionsButtonText = param.ConfirmOptionsButtonText, ManageButtonText = param.ManageButtonText, ManageDecription = param.ManageDecription, ManageOptions = param.ManageOptions, ManageTitle = param.ManageTitle, RejectAllButtonText = param.RejectAllButtonText, RejectButtonText = param.RejectButtonText, ResponseMessage = param.ResponseMessage, UndoButtonText = param.UndoButtonText, closeBanner = param.closeBanner, MainBannerIcon = param.MainBannerIcon;
    var ref, ref1;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), showManageWindow = ref2[0], setShowManageWindow = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), showSuccessWindow = ref3[0], setShowSuccessWindow = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState([]), 2), checkedOptions = ref4[0], setCheckedOptions = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        // set the always checked options to be part of the checked array
        setCheckedOptions((ref = ManageOptions === null || ManageOptions === void 0 ? void 0 : ManageOptions.map(function(option) {
            var ref, ref1;
            return (option === null || option === void 0 ? void 0 : (ref = option.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.alwaysActive) === null || ref1 === void 0 ? void 0 : ref1.value) === true ? {
                id: option === null || option === void 0 ? void 0 : option.id,
                name: option === null || option === void 0 ? void 0 : option.name,
                checked: true
            } : {
                id: option === null || option === void 0 ? void 0 : option.id,
                name: option === null || option === void 0 ? void 0 : option.name,
                checked: false
            };
        })) !== null && ref !== void 0 ? ref : []);
    }, []);
    // Auto-close the success window (undo banner) after 10 seconds if user doesn't interact
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (showSuccessWindow) {
            var timer = setTimeout(function() {
                closeAll();
            }, 10000); // 10 seconds
            return function() {
                clearTimeout(timer);
            };
        }
        return undefined;
    }, [
        showSuccessWindow
    ]);
    var closeAll = function() {
        setShowManageWindow(false);
        setShowSuccessWindow(false);
        closeBanner();
    };
    var saveConsentHttpOnly = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(optionsJson) {
            var res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("/api/consent/cookies", {
                                method: "POST",
                                credentials: "include",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    options: optionsJson
                                })
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        if (!res.ok) {
                            throw new Error("Failed to save cookie consent");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function saveConsentHttpOnly(optionsJson) {
            return _ref.apply(this, arguments);
        };
    }();
    var clearConsentHttpOnly = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("/api/consent/cookies", {
                                method: "DELETE",
                                credentials: "include"
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        if (!res.ok) {
                            throw new Error("Failed to clear cookie consent");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function clearConsentHttpOnly() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAccept = function() {
        void (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            saveConsentHttpOnly(JSON.stringify(ManageOptions === null || ManageOptions === void 0 ? void 0 : ManageOptions.map(function(option) {
                                return {
                                    id: option === null || option === void 0 ? void 0 : option.id,
                                    name: option === null || option === void 0 ? void 0 : option.name,
                                    checked: true
                                };
                            })))
                        ];
                    case 1:
                        _state.sent();
                        setShowSuccessWindow(true);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        setShowSuccessWindow(true);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var handleReject = function() {
        // cookies rejected nothing will happen
        closeAll();
    };
    var handleManage = function() {
        setShowManageWindow(true);
    };
    var handleUndo = function() {
        void (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        return [
                            4,
                            clearConsentHttpOnly()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setShowManageWindow(false);
                        setShowSuccessWindow(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var handleConfirmOptions = function() {
        void (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        return [
                            4,
                            saveConsentHttpOnly(JSON.stringify(checkedOptions))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setShowManageWindow(false);
                        setShowSuccessWindow(true);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var RejectAll = function() {
        setCheckedOptions([]);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "fixed top-0 ".concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_5__["default"])() ? "right-0" : "left-0", " !z-[99999] w-screen h-screen bg-[#00000050]"),
        onClick: function(e) {
            if (e.target === e.currentTarget) {
                closeBanner();
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "shadow-[0_0px_30px_rgba(0,0,0,0.1)] fixed bottom-0 w-full bg-white !z-[9999]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "responsive py-4 md:py-8 flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center justify-between ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    (MainBannerIcon === null || MainBannerIcon === void 0 ? void 0 : (ref = MainBannerIcon.value) === null || ref === void 0 ? void 0 : ref.src) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        unoptimized: true,
                                        src: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_4__.extractRelativePath)(MainBannerIcon === null || MainBannerIcon === void 0 ? void 0 : (ref1 = MainBannerIcon.value) === null || ref1 === void 0 ? void 0 : ref1.src),
                                        alt: "cookies-icon",
                                        width: 40,
                                        height: 40,
                                        layout: "intrinsic"
                                    }),
                                    !showManageWindow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: (BannerTitle === null || BannerTitle === void 0 ? void 0 : BannerTitle.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "text-lg font-semibold",
                                            children: BannerTitle.value
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: (ManageTitle === null || ManageTitle === void 0 ? void 0 : ManageTitle.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "text-lg font-semibold",
                                            children: ManageTitle.value
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_6__.DGAButton, {
                                size: "iconOnly lg",
                                variant: "secondarySolid",
                                onClick: function() {
                                    return closeAll();
                                },
                                "aria-label": "Close cookies banner",
                                buttonContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_10__, {
                                    width: 24,
                                    height: 24,
                                    "aria-hidden": true
                                })
                            })
                        ]
                    }),
                    !showSuccessWindow && !showManageWindow && (BannerDescription === null || BannerDescription === void 0 ? void 0 : BannerDescription.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "[&_a]:text-primary-800 [&_a:hover]:text-primary-900",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_11__/* .RichText */ .H, {
                            field: BannerDescription
                        })
                    }),
                    !showSuccessWindow && showManageWindow && (ManageDecription === null || ManageDecription === void 0 ? void 0 : ManageDecription.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "[&_a]:text-primary-800 [&_a:hover]:text-primary-900",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_11__/* .RichText */ .H, {
                            field: ManageDecription
                        })
                    }),
                    !showSuccessWindow && !showManageWindow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            (AcceptButtonText === null || AcceptButtonText === void 0 ? void 0 : AcceptButtonText.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_6__.DGAButton, {
                                size: "md",
                                variant: "primary",
                                className: "!w-full",
                                onClick: function() {
                                    return handleAccept();
                                },
                                buttonContent: AcceptButtonText === null || AcceptButtonText === void 0 ? void 0 : AcceptButtonText.value
                            }),
                            (RejectButtonText === null || RejectButtonText === void 0 ? void 0 : RejectButtonText.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_6__.DGAButton, {
                                size: "md",
                                variant: "secondaryOutline",
                                className: "!w-full",
                                onClick: function() {
                                    return handleReject();
                                },
                                buttonContent: RejectButtonText === null || RejectButtonText === void 0 ? void 0 : RejectButtonText.value
                            }),
                            (ManageButtonText === null || ManageButtonText === void 0 ? void 0 : ManageButtonText.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_6__.DGAButton, {
                                size: "md",
                                variant: "secondarySolid",
                                className: "!w-full",
                                onClick: function() {
                                    return handleManage();
                                },
                                buttonContent: ManageButtonText === null || ManageButtonText === void 0 ? void 0 : ManageButtonText.value
                            })
                        ]
                    }),
                    showManageWindow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            ManageOptions && (ManageOptions === null || ManageOptions === void 0 ? void 0 : ManageOptions.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col gap-4",
                                children: ManageOptions === null || ManageOptions === void 0 ? void 0 : ManageOptions.map(function(option) {
                                    var ref = (option === null || option === void 0 ? void 0 : option.fields) || {}, Label = ref.Label, AlwaysActive = ref.AlwaysActive, AlwaysActiveText = ref.AlwaysActiveText;
                                    return (Label === null || Label === void 0 ? void 0 : Label.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                        htmlFor: option === null || option === void 0 ? void 0 : option.id,
                                        className: "flex gap-2 items-start cursor-pointer w-full",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CookieBannerToggleSwitch__WEBPACK_IMPORTED_MODULE_3__.CookieBannerToggleSwitch, {
                                                checked: (checkedOptions === null || checkedOptions === void 0 ? void 0 : checkedOptions.find(function(item) {
                                                    return item.id === (option === null || option === void 0 ? void 0 : option.id) && (item === null || item === void 0 ? void 0 : item.checked);
                                                })) ? true : false,
                                                onChange: function(param) {
                                                    var id = param.id, name = param.name, checked = param.checked;
                                                    if (checked) {
                                                        setCheckedOptions(function(prev) {
                                                            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(prev).concat([
                                                                {
                                                                    id: id,
                                                                    name: name,
                                                                    checked: checked
                                                                }, 
                                                            ]);
                                                        });
                                                    } else {
                                                        setCheckedOptions(function(prev) {
                                                            return prev.filter(function(item) {
                                                                return item.id !== id;
                                                            });
                                                        });
                                                    }
                                                },
                                                id: option === null || option === void 0 ? void 0 : option.id,
                                                name: option === null || option === void 0 ? void 0 : option.name,
                                                alwaysActive: AlwaysActive === null || AlwaysActive === void 0 ? void 0 : AlwaysActive.value
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex min-w-0 flex-1 flex-col gap-1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "text-primary-1000 text-sm",
                                                        children: Label === null || Label === void 0 ? void 0 : Label.value
                                                    }),
                                                    (AlwaysActive === null || AlwaysActive === void 0 ? void 0 : AlwaysActive.value) && (AlwaysActiveText === null || AlwaysActiveText === void 0 ? void 0 : AlwaysActiveText.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "text-neutral-600 text-sm",
                                                        children: AlwaysActiveText === null || AlwaysActiveText === void 0 ? void 0 : AlwaysActiveText.value
                                                    })
                                                ]
                                            })
                                        ]
                                    }, option === null || option === void 0 ? void 0 : option.id);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col gap-2 py-4",
                                children: [
                                    (ConfirmOptionsButtonText === null || ConfirmOptionsButtonText === void 0 ? void 0 : ConfirmOptionsButtonText.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_6__.DGAButton, {
                                        size: "md",
                                        variant: "primary",
                                        className: "!w-full",
                                        onClick: function() {
                                            return handleConfirmOptions();
                                        },
                                        buttonContent: ConfirmOptionsButtonText === null || ConfirmOptionsButtonText === void 0 ? void 0 : ConfirmOptionsButtonText.value
                                    }),
                                    (RejectAllButtonText === null || RejectAllButtonText === void 0 ? void 0 : RejectAllButtonText.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_6__.DGAButton, {
                                        size: "md",
                                        variant: "secondaryOutline",
                                        className: "!w-full",
                                        buttonContent: RejectAllButtonText === null || RejectAllButtonText === void 0 ? void 0 : RejectAllButtonText.value,
                                        onClick: function() {
                                            return RejectAll();
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    showSuccessWindow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col gap-4",
                        children: [
                            (ResponseMessage === null || ResponseMessage === void 0 ? void 0 : ResponseMessage.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_11__/* .RichText */ .H, {
                                field: ResponseMessage
                            }),
                            (UndoButtonText === null || UndoButtonText === void 0 ? void 0 : UndoButtonText.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_6__.DGAButton, {
                                size: "md",
                                variant: "secondarySolid",
                                className: "!w-full",
                                onClick: function() {
                                    return handleUndo();
                                },
                                buttonContent: UndoButtonText === null || UndoButtonText === void 0 ? void 0 : UndoButtonText.value
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CookiesBanner);


/***/ }),

/***/ 15481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87664);
/* harmony import */ var lib_linkExternalProps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18693);
/* harmony import */ var lib_newWindowA11y__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92248);




/** Matches chat FAB stack: bottom-5 + chat button (~3.375rem) + gap-2 (0.5rem). */ var EHSAN_BOTTOM_OFFSET = "calc(1.25rem + 3.375rem + 0.5rem)";
var DISPLAY_SIZE_PX = 54;
var resolveIconSrc = function(src) {
    var resolved = (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_1__.extractRelativePath)(src);
    if (resolved.startsWith("http")) return resolved;
    var host = ("https://c-admin.takamulstg.com" || 0).replace(/\/$/, "");
    return "".concat(host).concat(resolved.startsWith("/") ? resolved : "/".concat(resolved));
};
var EhsanFloatingButton = function(param) {
    var locale = param.locale, show = param.show, linkField = param.linkField, iconField = param.iconField;
    var ref, ref1, ref2, ref3, ref4;
    if (!show) return null;
    var href = (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_1__.CleanRelativeLink)(linkField === null || linkField === void 0 ? void 0 : (ref = linkField.value) === null || ref === void 0 ? void 0 : ref.href);
    var iconSrc = iconField === null || iconField === void 0 ? void 0 : (ref1 = iconField.value) === null || ref1 === void 0 ? void 0 : ref1.src;
    if (!href || !iconSrc) return null;
    var target = ((linkField === null || linkField === void 0 ? void 0 : (ref2 = linkField.value) === null || ref2 === void 0 ? void 0 : ref2.target) || "_self").trim() || "_self";
    var linkText = (linkField === null || linkField === void 0 ? void 0 : (ref3 = linkField.value) === null || ref3 === void 0 ? void 0 : ref3.text) && String(linkField.value.text).trim();
    var isPlaceholderLabel = !linkText || linkText === "$name";
    var labelBase = !isPlaceholderLabel && linkText || (iconField === null || iconField === void 0 ? void 0 : (ref4 = iconField.value) === null || ref4 === void 0 ? void 0 : ref4.alt) && String(iconField.value.alt).trim() || "Ehsan";
    var ariaLabel = (0,lib_linkExternalProps__WEBPACK_IMPORTED_MODULE_2__/* .isBlankTarget */ .S)(target) ? (0,lib_newWindowA11y__WEBPACK_IMPORTED_MODULE_3__/* .ariaLabelWithNewWindowNotice */ .wI)(labelBase, locale) : labelBase;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        target: target,
        rel: (0,lib_linkExternalProps__WEBPACK_IMPORTED_MODULE_2__/* .relForBlankTarget */ .H)(target),
        title: (0,lib_linkExternalProps__WEBPACK_IMPORTED_MODULE_2__/* .isBlankTarget */ .S)(target) ? (0,lib_newWindowA11y__WEBPACK_IMPORTED_MODULE_3__/* .newWindowNoticeTitle */ .yB)(locale) : undefined,
        "aria-label": ariaLabel,
        className: "fixed right-5 z-[500] block shrink-0 cursor-pointer overflow-hidden rounded-full transition-opacity hover:opacity-90",
        style: {
            bottom: EHSAN_BOTTOM_OFFSET,
            width: DISPLAY_SIZE_PX,
            height: DISPLAY_SIZE_PX
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: resolveIconSrc(iconSrc),
            alt: "",
            "aria-hidden": true,
            className: "absolute inset-0 h-full w-full object-cover"
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (EhsanFloatingButton);


/***/ }),

/***/ 6470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62009);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
// import IsRtl from "components/Shared/isRtl";



var FooterDecorativeOverlaySvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        alt: "footer decorative overlay",
        "aria-hidden": "true",
        "aria-label": "footer decorative overlay",
        className: "".concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_1__["default"])() ? "" : "scale-x-[-1] scale-y-[1]"),
        loading: "lazy",
        src: "/FooterLogoFoundingDay.png",
        layout: "fill"
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FooterDecorativeOverlaySvg);


/***/ }),

/***/ 4741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ GreyScaleAccessToolButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63651);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var lib_dgaGrayscaleMode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59573);




function GreyScaleAccessToolButton() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isGrayscale = ref[0], setIsGrayscale = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setIsGrayscale((0,lib_dgaGrayscaleMode__WEBPACK_IMPORTED_MODULE_3__/* .getGrayscaleModeEnabled */ .l)());
        var onChange = function() {
            return setIsGrayscale((0,lib_dgaGrayscaleMode__WEBPACK_IMPORTED_MODULE_3__/* .getGrayscaleModeEnabled */ .l)());
        };
        window.addEventListener(lib_dgaGrayscaleMode__WEBPACK_IMPORTED_MODULE_3__/* .DGA_GRAYSCALE_CHANGE_EVENT */ .pf, onChange);
        return function() {
            return window.removeEventListener(lib_dgaGrayscaleMode__WEBPACK_IMPORTED_MODULE_3__/* .DGA_GRAYSCALE_CHANGE_EVENT */ .pf, onChange);
        };
    }, []);
    var toggleGrayscale = function() {
        setIsGrayscale((0,lib_dgaGrayscaleMode__WEBPACK_IMPORTED_MODULE_3__/* .toggleGrayscaleMode */ .b6)());
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_1__.DGAButton, {
        variant: "secondaryOutline",
        onClick: toggleGrayscale,
        className: isGrayscale ? "!bg-white/20 !border-white" : "",
        "aria-label": isGrayscale ? "Disable grayscale mode" : "Enable grayscale mode",
        "aria-pressed": isGrayscale,
        buttonContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.9974 13.1253C8.27151 13.1253 6.8724 11.7262 6.8724 10.0003C6.8724 8.27444 8.27151 6.87533 9.9974 6.87533C11.7233 6.87533 13.1224 8.27444 13.1224 10.0003C13.1224 11.7262 11.7233 13.1253 9.9974 13.1253ZM8.1224 10.0003C8.1224 11.0359 8.96186 11.8753 9.9974 11.8753C11.0329 11.8753 11.8724 11.0359 11.8724 10.0003C11.8724 8.96479 11.0329 8.12533 9.9974 8.12533C8.96186 8.12533 8.1224 8.96479 8.1224 10.0003Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.9974 3.54199C7.85526 3.54199 6.01902 4.48483 4.59765 5.59448C3.175 6.70512 2.12345 8.01678 1.53524 8.84159L1.49089 8.90344C1.27993 9.19684 1.03906 9.53182 1.03906 10.0003C1.03906 10.4688 1.27993 10.8038 1.49089 11.0972L1.53524 11.1591C2.12345 11.9839 3.175 13.2955 4.59765 14.4062C6.01902 15.5158 7.85526 16.4587 9.9974 16.4587C12.1395 16.4587 13.9758 15.5158 15.3971 14.4062C16.8198 13.2955 17.8713 11.9839 18.4596 11.1591L18.5039 11.0972C18.7149 10.8038 18.9557 10.4688 18.9557 10.0003C18.9557 9.53182 18.7149 9.19684 18.5039 8.90344L18.4596 8.84159C17.8713 8.01678 16.8198 6.70512 15.3971 5.59448C13.9758 4.48483 12.1395 3.54199 9.9974 3.54199ZM2.55295 9.56737C3.10312 8.7959 4.07438 7.58881 5.36686 6.57978C6.66062 5.56975 8.23185 4.79199 9.9974 4.79199C11.7629 4.79199 13.3342 5.56975 14.6279 6.57978C15.9204 7.58881 16.8917 8.7959 17.4418 9.56737C17.5779 9.75822 17.6427 9.85141 17.6813 9.92559C17.7059 9.97275 17.7058 9.98568 17.7057 9.99833L17.7057 10.0003L17.7057 10.0023C17.7058 10.015 17.7059 10.0279 17.6813 10.0751C17.6427 10.1492 17.5779 10.2424 17.4418 10.4333C16.8917 11.2048 15.9204 12.4118 14.6279 13.4209C13.3342 14.4309 11.7629 15.2087 9.9974 15.2087C8.23185 15.2087 6.66063 14.4309 5.36686 13.4209C4.07438 12.4118 3.10312 11.2048 2.55296 10.4333C2.41685 10.2424 2.35208 10.1492 2.31346 10.0751C2.28892 10.0279 2.28899 10.015 2.28906 10.0023L2.28906 10.0003L2.28906 9.99833C2.28899 9.98568 2.28892 9.97275 2.31346 9.92559C2.35208 9.85141 2.41685 9.75822 2.55295 9.56737Z",
                    fill: "currentColor"
                })
            ]
        }),
        size: "iconOnly md"
    });
}


/***/ }),

/***/ 49587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _SuccessMessagePopupCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29432);
/* harmony import */ var _SubscribeToNewsLetterForm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63865);
/* harmony import */ var components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62009);
/* harmony import */ var components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63651);
/* eslint-disable @typescript-eslint/no-explicit-any */ 




// import { DGAButton } from "components/Shared/dga-button/DGAButton";


var SubscribeToNewsLetter = function(param) {
    var buttonText = param.buttonText, locale = param.locale, NewsLetterFormData = param.NewsLetterFormData, isBottomLink = param.isBottomLink;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), isPopupOpen = ref6[0], setPopupOpen = ref6[1];
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({
        success: false,
        message: ""
    }), 2), subscribeFormResponse = ref7[0], setSubscribeFormResponse = ref7[1];
    var ref8 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), isSubscribeFormLoading = ref8[0], setIsSubscribeFormLoading = ref8[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isPopupOpen) {
            setSubscribeFormResponse({
                success: false,
                message: ""
            });
            setIsSubscribeFormLoading(false);
        }
    }, [
        isPopupOpen
    ]);
    if (!buttonText) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            isBottomLink == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_5__.DGAButton, {
                variant: "secondaryOutline",
                size: "md",
                buttonContent: buttonText,
                onClick: function() {
                    return setPopupOpen(true);
                }
            }),
            isBottomLink == true && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                onClick: function() {
                    return setPopupOpen(true);
                },
                className: "text-primary-1000 cursor-pointer hover:text-primary-1000/80 hover:underline underline text-[14px] bg-transparent border-0 p-0 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600 focus-visible:ring-offset-2 rounded",
                children: buttonText
            }),
            isPopupOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                dir: (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_4__["default"])() ? "rtl" : "ltr",
                className: "fixed top-0 left-0 right-0 bottom-0 w-screen h-screen flex items-center justify-center text-white bg-gray-600 bg-opacity-70 z-[10000] p-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: function(e) {
                            e.stopPropagation();
                            setPopupOpen(false);
                        },
                        className: "absolute w-full h-full top-0 left-0 right-0 bottom-0 bg-transparent z-10 transition-colors animate-appearance-in"
                    }),
                    (subscribeFormResponse === null || subscribeFormResponse === void 0 ? void 0 : subscribeFormResponse.success) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SuccessMessagePopupCard__WEBPACK_IMPORTED_MODULE_2__["default"], {
                        Title: NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref = NewsLetterFormData.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Title) === null || ref1 === void 0 ? void 0 : ref1.value,
                        Subtitle: NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref2 = NewsLetterFormData.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Subtitle) === null || ref3 === void 0 ? void 0 : ref3.value,
                        Description: NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref4 = NewsLetterFormData.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Description) === null || ref5 === void 0 ? void 0 : ref5.value,
                        setPopupOpen: setPopupOpen
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SubscribeToNewsLetterForm__WEBPACK_IMPORTED_MODULE_3__["default"], {
                        locale: locale,
                        isSubscribeFormLoading: isSubscribeFormLoading,
                        NewsLetterFormData: NewsLetterFormData,
                        subscribeFormResponseMessage: subscribeFormResponse === null || subscribeFormResponse === void 0 ? void 0 : subscribeFormResponse.message,
                        setSubscribeFormResponse: setSubscribeFormResponse,
                        setPopupOpen: setPopupOpen,
                        setIsSubscribeFormLoading: setIsSubscribeFormLoading
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(SubscribeToNewsLetter));


/***/ }),

/***/ 63865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98077);
/* harmony import */ var components_Shared_icons_cancel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11776);
/* harmony import */ var components_Shared_DGA_inputs_DGA_input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(130);
/* harmony import */ var components_Shared_dga_checkbox_input_DGACheckboxInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4145);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(16606);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92413);
/* harmony import */ var components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63651);















var allowedKeys = [
    "Backspace",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
    "Tab"
];
var SubscribeToNewsLetterForm = function(param) {
    var locale = param.locale, isSubscribeFormLoading = param.isSubscribeFormLoading, NewsLetterFormData = param.NewsLetterFormData, setSubscribeFormResponse = param.setSubscribeFormResponse, setPopupOpen = param.setPopupOpen, setIsSubscribeFormLoading = param.setIsSubscribeFormLoading;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46;
    var ref47 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({
        name: "",
        email: "",
        phononumber: ""
    }), 2), formFieldsPatternError = ref47[0], setFormFieldsPatternError = ref47[1];
    var ref48 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), termsAndConditionsCheckbox = ref48[0], setTermsAndConditionsCheckbox = ref48[1];
    var ref49 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), marketingEmailsCheckbox = ref49[0], setMarketingEmailsCheckbox = ref49[1];
    var ref50 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), captcha = ref50[0], setCaptcha = ref50[1];
    var ref51 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), captchaError = ref51[0], setCaptchaError = ref51[1];
    var ref52 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        name: "",
        email: ""
    }), formValues = ref52[0], setFormValues = ref52[1];
    var sitekey = "6LfTSI4jAAAAAI41yLanFCkt2HaGfgD1jdCBZuac" || 0;
    var validateEmail = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(email) {
            var ref, ref1, ref2, ref3, schema, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        schema = yup__WEBPACK_IMPORTED_MODULE_3__/* .object */ .Ry().shape({
                            email: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().email(NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref = NewsLetterFormData.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.EmailPatternErrorText) === null || ref1 === void 0 ? void 0 : ref1.value).required(NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref2 = NewsLetterFormData.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.GlobalRquiredFieldErrorText) === null || ref3 === void 0 ? void 0 : ref3.value)
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            schema.validate({
                                email: email
                            }, {
                                abortEarly: false
                            })
                        ];
                    case 2:
                        _state.sent();
                        if (formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : formFieldsPatternError.email) {
                            setFormFieldsPatternError(function(prev) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, prev), {
                                    email: ""
                                });
                            });
                        }
                        return [
                            2,
                            true
                        ];
                    case 3:
                        error = _state.sent();
                        if ((formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : formFieldsPatternError.email) !== (error === null || error === void 0 ? void 0 : error.message)) {
                            setFormFieldsPatternError(function(prev) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, prev), {
                                    email: error === null || error === void 0 ? void 0 : error.message
                                });
                            });
                        }
                        return [
                            2,
                            false
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(email) {
            return _ref.apply(this, arguments);
        };
    }(), [
        formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : formFieldsPatternError.email,
        NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref = NewsLetterFormData.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.EmailPatternErrorText) === null || ref1 === void 0 ? void 0 : ref1.value,
        NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref2 = NewsLetterFormData.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.GlobalRquiredFieldErrorText) === null || ref3 === void 0 ? void 0 : ref3.value, 
    ]);
    var handleNameBlur = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        if (!e.target.value && !(formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : formFieldsPatternError.name)) {
            setFormFieldsPatternError(function(prev) {
                var ref, ref1;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, prev), {
                    name: NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref = NewsLetterFormData.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.GlobalRquiredFieldErrorText) === null || ref1 === void 0 ? void 0 : ref1.value
                });
            });
        }
        if (e.target.value && (formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : formFieldsPatternError.name)) {
            setFormFieldsPatternError(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, prev), {
                    name: ""
                });
            });
        }
    }, [
        formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : formFieldsPatternError.name,
        NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref4 = NewsLetterFormData.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.GlobalRquiredFieldErrorText) === null || ref5 === void 0 ? void 0 : ref5.value,
        setFormFieldsPatternError, 
    ]);
    var handleNameChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        setFormValues(function(prev) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, prev), {
                name: e.target.value
            });
        });
        if ((formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : formFieldsPatternError.name) && e.target.value) {
            setFormFieldsPatternError(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, prev), {
                    name: ""
                });
            });
        } else if (!(formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : formFieldsPatternError.name) && !e.target.value) {
            setFormFieldsPatternError(function(prev) {
                var ref, ref1;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, prev), {
                    name: NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref = NewsLetterFormData.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.GlobalRquiredFieldErrorText) === null || ref1 === void 0 ? void 0 : ref1.value
                });
            });
        }
    }, [
        formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : formFieldsPatternError.name,
        NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref6 = NewsLetterFormData.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.GlobalRquiredFieldErrorText) === null || ref7 === void 0 ? void 0 : ref7.value,
        setFormFieldsPatternError, 
    ]);
    var handleEmailBlur = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        var ref;
        validateEmail(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
    }, [
        validateEmail
    ]);
    var handleEmailChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        setFormValues(function(prev) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, prev), {
                email: e.target.value
            });
        });
        if (formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : formFieldsPatternError.email) {
            var ref;
            validateEmail(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
        }
    }, [
        formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : formFieldsPatternError.email,
        validateEmail
    ]);
    var handlePhoneNumberFieldKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
            e.preventDefault();
        }
    }, [
        allowedKeys
    ]);
    var handleSubscribeToNewsLetter = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(e) {
            var formData, Name, Email, PhoneNumber, response, error, ref, ref1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (!captcha) {
                            setCaptchaError(true);
                            return [
                                2
                            ];
                        }
                        setCaptchaError(false);
                        setIsSubscribeFormLoading(true);
                        setSubscribeFormResponse({
                            success: false,
                            message: ""
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        formData = new FormData(e.currentTarget);
                        Name = formData.get("name");
                        Email = formData.get("email");
                        PhoneNumber = formData.get("phononumber");
                        //   const MarketingEmails = formData.get("marketingEmails") as string;
                        //   const TermsAndConditions = formData.get("termsAndConditions") as string;
                        return [
                            4,
                            validateEmail(Email)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_2___default().post("".concat("https://c-admin.takamulstg.com", "/api/Subscription/moc/Submit"), {
                                Language: locale,
                                Name: Name,
                                Email: Email,
                                PhoneNumber: PhoneNumber,
                                MarketingEmails: marketingEmailsCheckbox,
                                TermsAndConditions: termsAndConditionsCheckbox,
                                CaptchaResponse: captcha
                            }, {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        ];
                    case 3:
                        response = _state.sent();
                        setSubscribeFormResponse({
                            success: true,
                            message: response === null || response === void 0 ? void 0 : response.data
                        });
                        setIsSubscribeFormLoading(false);
                        setCaptcha(null); // Reset captcha after successful submission
                        setCaptchaError(false); // Reset captcha error
                        setFormValues({
                            name: "",
                            email: ""
                        }); // Reset form values after successful submission
                        setTermsAndConditionsCheckbox(false); // Reset checkboxes
                        setMarketingEmailsCheckbox(false);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.error(error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.data);
                        setSubscribeFormResponse({
                            success: false,
                            message: (error === null || error === void 0 ? void 0 : (ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.data) || "Something went wrong!"
                        });
                        setIsSubscribeFormLoading(false);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubscribeToNewsLetter(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCaptchaChange = function(value) {
        setCaptcha(value);
        // Clear captcha error when user completes it
        if (value) {
            setCaptchaError(false);
        }
    };
    // Check if submit button should be disabled
    var isSubmitDisabled = isSubscribeFormLoading || !captcha || !formValues.name.trim() || !formValues.email.trim() || !termsAndConditionsCheckbox;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col rounded-lg items-start gap-5 p-5 bg-white max-w-sm w-full z-20 animate-appearance-in max-h-[90vh] overflow-y-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                onClick: function() {
                    return setPopupOpen(false);
                },
                "aria-label": "Close newsletter dialog",
                className: "flex items-center justify-center w-fit self-end p-1 hover:!bg-[#edebea] transition-colors rounded sticky top-0 bg-white z-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_icons_cancel__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    color: "#161616",
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                onSubmit: handleSubscribeToNewsLetter,
                className: "flex flex-col items-start gap-5 w-full",
                children: [
                    ((NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref8 = NewsLetterFormData.fields) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.NameLabel) === null || ref9 === void 0 ? void 0 : ref9.value) || (NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref10 = NewsLetterFormData.fields) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.NamePlaceholder) === null || ref11 === void 0 ? void 0 : ref11.value)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_DGA_inputs_DGA_input__WEBPACK_IMPORTED_MODULE_5__["default"], {
                        label: NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref12 = NewsLetterFormData.fields) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.NameLabel) === null || ref13 === void 0 ? void 0 : ref13.value,
                        id: "name",
                        name: "name",
                        type: "text",
                        required: true,
                        placeholder: NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref14 = NewsLetterFormData.fields) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.NamePlaceholder) === null || ref15 === void 0 ? void 0 : ref15.value,
                        onBlur: handleNameBlur,
                        onChange: handleNameChange,
                        error: (formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : (ref16 = formFieldsPatternError.name) === null || ref16 === void 0 ? void 0 : ref16.length) > 0,
                        errorMessage: formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : formFieldsPatternError.name,
                        InputSize: "lg",
                        variant: "Filled-Darker"
                    }),
                    ((NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref17 = NewsLetterFormData.fields) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.EmailLabel) === null || ref18 === void 0 ? void 0 : ref18.value) || (NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref19 = NewsLetterFormData.fields) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.EmailPlaceholder) === null || ref20 === void 0 ? void 0 : ref20.value)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_DGA_inputs_DGA_input__WEBPACK_IMPORTED_MODULE_5__["default"], {
                        label: NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref21 = NewsLetterFormData.fields) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.EmailLabel) === null || ref22 === void 0 ? void 0 : ref22.value,
                        name: "email",
                        type: "email",
                        required: true,
                        placeholder: NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref23 = NewsLetterFormData.fields) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.EmailPlaceholder) === null || ref24 === void 0 ? void 0 : ref24.value,
                        onChange: handleEmailChange,
                        onBlur: handleEmailBlur,
                        error: (formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : (ref25 = formFieldsPatternError.email) === null || ref25 === void 0 ? void 0 : ref25.length) > 0,
                        errorMessage: formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : formFieldsPatternError.email,
                        InputSize: "lg",
                        variant: "Filled-Darker"
                    }),
                    ((NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref26 = NewsLetterFormData.fields) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.PhoneNumberLabel) === null || ref27 === void 0 ? void 0 : ref27.value) || (NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref28 = NewsLetterFormData.fields) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.PhoneNumberPlaceholder) === null || ref29 === void 0 ? void 0 : ref29.value)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_DGA_inputs_DGA_input__WEBPACK_IMPORTED_MODULE_5__["default"], {
                        label: (NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref30 = NewsLetterFormData.fields) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.PhoneNumberLabel) === null || ref31 === void 0 ? void 0 : ref31.value) + " " + (NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref32 = NewsLetterFormData.fields) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.OptionalInputLabelSuffix) === null || ref33 === void 0 ? void 0 : ref33.value),
                        id: "phononumber",
                        name: "phononumber",
                        type: "phononumber",
                        error: (formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : (ref34 = formFieldsPatternError.phononumber) === null || ref34 === void 0 ? void 0 : ref34.length) > 0,
                        errorMessage: formFieldsPatternError === null || formFieldsPatternError === void 0 ? void 0 : formFieldsPatternError.phononumber,
                        InputSize: "lg",
                        onKeyDown: handlePhoneNumberFieldKeyDown,
                        maxLength: 25,
                        placeholder: NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref35 = NewsLetterFormData.fields) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.PhoneNumberPlaceholder) === null || ref36 === void 0 ? void 0 : ref36.value,
                        variant: "Filled-Darker"
                    }),
                    (NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref37 = NewsLetterFormData.fields) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.TermsAndConditionsLabel) === null || ref38 === void 0 ? void 0 : ref38.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_checkbox_input_DGACheckboxInput__WEBPACK_IMPORTED_MODULE_6__.DGACheckboxInput, {
                                size: "md",
                                id: "termsAndConditions",
                                checked: termsAndConditionsCheckbox,
                                variant: "primary",
                                onChange: function() {
                                    setTermsAndConditionsCheckbox(function(prev) {
                                        return !prev;
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                htmlFor: "termsAndConditions",
                                className: "text-primary-1000",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_14__/* .RichText */ .H, {
                                    field: NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref39 = NewsLetterFormData.fields) === null || ref39 === void 0 ? void 0 : ref39.TermsAndConditionsLabel
                                })
                            })
                        ]
                    }),
                    (NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref40 = NewsLetterFormData.fields) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.MarketingEmailsLabel) === null || ref41 === void 0 ? void 0 : ref41.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_checkbox_input_DGACheckboxInput__WEBPACK_IMPORTED_MODULE_6__.DGACheckboxInput, {
                                size: "md",
                                id: "marketingEmails",
                                checked: marketingEmailsCheckbox,
                                variant: "primary",
                                onChange: function() {
                                    setMarketingEmailsCheckbox(function(prev) {
                                        return !prev;
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                htmlFor: "marketingEmails",
                                className: "text-primary-1000",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_14__/* .RichText */ .H, {
                                    field: NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref42 = NewsLetterFormData.fields) === null || ref42 === void 0 ? void 0 : ref42.MarketingEmailsLabel
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center ".concat(captchaError ? "border-2 border-red-500 rounded p-1" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            sitekey: sitekey,
                            onChange: handleCaptchaChange,
                            hl: locale
                        })
                    }),
                    (NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref43 = NewsLetterFormData.fields) === null || ref43 === void 0 ? void 0 : (ref44 = ref43.SubmitButtonText) === null || ref44 === void 0 ? void 0 : ref44.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_8__.DGAButton, {
                        type: "submit",
                        disabled: isSubmitDisabled,
                        size: "lg",
                        variant: "primary",
                        buttonContent: NewsLetterFormData === null || NewsLetterFormData === void 0 ? void 0 : (ref45 = NewsLetterFormData.fields) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.SubmitButtonText) === null || ref46 === void 0 ? void 0 : ref46.value,
                        className: "min-w-[85px] w-fit min-h-[42px] whitespace-nowrap"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(SubscribeToNewsLetterForm));


/***/ }),

/***/ 29432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_Shared_icons_cancel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11776);
/* harmony import */ var components_Shared_icons_featured__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77234);




var SuccessMessagePopupCard = function(param) {
    var Title = param.Title, Subtitle = param.Subtitle, Description = param.Description, setPopupOpen = param.setPopupOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "max-w-[600px] rounded-lg p-6 flex flex-col items-start gap-2 bg-white z-30",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-start justify-between w-full gap-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-center w-10 h-10 rounded-full bg-neutral-50",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_icons_featured__WEBPACK_IMPORTED_MODULE_3__["default"], {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        onClick: function() {
                            return setPopupOpen(false);
                        },
                        "aria-label": "Close success message",
                        className: "cursor-pointer flex items-center justify-center w-fit p-0.5 hover:!bg-[#edebea] transition-colors rounded",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_icons_cancel__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            color: "#161616",
                            "aria-hidden": true
                        })
                    })
                ]
            }),
            Title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "font-semibold text-lg text-neutral-800",
                children: Title
            }),
            Subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "font-semibold text-lg text-neutral-800 mt-4",
                children: Subtitle
            }),
            Description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "textsm text-neutral-700",
                children: Description
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(SuccessMessagePopupCard));


/***/ }),

/***/ 91601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11355);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62009);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24819);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_icons_hi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53854);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);








var LanguagesDropdown = function(param) {
    var currentLocale = param.currentLocale, labels = param.labels, unSupportedLocales = param.unSupportedLocales;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var menuRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var isRtl = (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_3__["default"])();
    var onOverlayClick = function(e) {
        if (menuRef.current && e.target === e.currentTarget) {
            setIsOpen(false);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative font-effra inline-block w-full lg:w-fit text-left",
        ref: menuRef,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                onClick: function() {
                    return setIsOpen(function(prev) {
                        return !prev;
                    });
                },
                className: "!font-bold group relative text-sm xl:text-base border-b border-black lg:border-0 px-2 pt-5 pb-[16px] w-full xl:py-6 flex items-center gap-1 transition-colors\n          ".concat(!isOpen ? "lg:hover:bg-neutral-200" : "", "\n          ").concat(isOpen ? "bg-neutral-200 lg:bg-oldTheme-secondary lg:!text-white" : "!text-black"),
                "aria-haspopup": "true",
                "aria-expanded": isOpen,
                children: [
                    labels.trigger,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "transition-transform duration-200 ".concat(isOpen ? "rotate-180" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_5__, {
                            width: 28,
                            height: 28,
                            color: "currentColor",
                            "aria-hidden": true
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: onOverlayClick,
                        className: "hidden lg:fixed inset-0 z-40 bg-transparent",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .u, {
                        as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
                        show: isOpen,
                        enter: "transition ease-out duration-200",
                        enterFrom: "opacity-0 translate-y-2",
                        enterTo: "opacity-100 translate-y-0",
                        leave: "transition ease-in duration-150",
                        leaveFrom: "opacity-100 translate-y-0",
                        leaveTo: "opacity-0 translate-y-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative lg:absolute mt-1 ".concat(isRtl ? "origin-top-left left-0" : "origin-top-right right-0", " lg:shadow-md w-[90vw] lg:w-48 lg:bg-white text-black focus:outline-none z-50"),
                            role: "menu",
                            "aria-orientation": "vertical",
                            "aria-labelledby": "language-menu-button",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col gap-0",
                                children: labels.options.map(function(opt, index) {
                                    var localeCode = opt.href.replace("/", "");
                                    var isUnsupported = unSupportedLocales.includes(localeCode);
                                    var isCurrent = currentLocale === localeCode;
                                    if (isUnsupported) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "group text-start text-sm xl:text-base font-medium p-3 w-full flex items-center justify-between transition-colors cursor-default\n                          ".concat(isCurrent ? "text-white bg-oldTheme-primary font-semibold" : "", "\n                        "),
                                            role: "menuitem",
                                            "aria-disabled": true,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "opacity-30",
                                                    children: opt.label
                                                }),
                                                opt.unsupportedText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "relative ml-2 group",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_7__/* .HiOutlineExclamationCircle */ .baL, {
                                                            size: 18,
                                                            className: "text-red-500",
                                                            "aria-hidden": "true"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .u, {
                                                            as: "div",
                                                            show: true,
                                                            enter: "transition ease-out duration-200",
                                                            enterFrom: "opacity-0 translate-y-1",
                                                            enterTo: "opacity-100 translate-y-0",
                                                            leave: "transition ease-in duration-150",
                                                            leaveFrom: "opacity-100 translate-y-0",
                                                            leaveTo: "opacity-0 translate-y-1",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: " absolute z-50 ".concat(isRtl ? "left-full" : "right-full", " top-6 w-max max-w-[200px] bg-white text-red-600 text-xs font-medium px-3 py-2 shadow-[0_0_15px_rgba(0,0,0,0.1)] hidden group-hover:block whitespace-normal"),
                                                                children: opt.unsupportedText
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, index);
                                    }
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: router.asPath,
                                        locale: localeCode,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            onClick: function() {
                                                return setIsOpen(false);
                                            },
                                            className: "text-start text-sm xl:text-base font-medium p-3 w-full\n                          transition-colors cursor-pointer flex items-center justify-between\n                          ".concat(isCurrent ? "text-white bg-oldTheme-primary font-semibold" : "hover:bg-neutral-200 lg:hover:bg-neutral-100", "\n                        "),
                                            role: "menuitem",
                                            children: opt.label
                                        })
                                    }, index);
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LanguagesDropdown);


/***/ }),

/***/ 82183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11355);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62009);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_icons_hi__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53854);
/* harmony import */ var components_Shared_icons_language_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22857);
/* harmony import */ var lib_switchLocale__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47719);











var LanguagesDropdown_DGA = function(param) {
    var currentLocale = param.currentLocale, labels = param.labels, unSupportedLocales = param.unSupportedLocales;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var menuRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var isRtl = (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_3__["default"])();
    var onOverlayClick = function(e) {
        if (menuRef.current && e.target === e.currentTarget) {
            setIsOpen(false);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative inline-block w-full lg:w-fit text-left",
        ref: menuRef,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                onClick: function() {
                    return setIsOpen(function(prev) {
                        return !prev;
                    });
                },
                "aria-label": "".concat(labels.trigger, ", language menu"),
                className: "group relative text-sm xl:text-base font-medium px-4 border-b border-black lg:border-0 py-5 w-full xl:px-4 lg:h-[72px] lg:py-0 xl:py-0 lg:rounded-tr lg:rounded-tl lg:rounded flex items-center gap-1 transition-colors justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-[#161616] lg:focus-visible:ring-offset-2 lg:focus:ring-2 lg:focus:ring-[#161616] lg:focus:ring-offset-2\n    ".concat(!isOpen ? "lg:hover:bg-[#F3F4F6] lg:active:bg-[#E5E7EB] text-black  mobile-nav-main-item-active lg:!rounded-sm !rounded-none" : "", "\n    ").concat(isOpen ? "bg-white text-[#1B8354] lg:bg-[#1B8354] lg:hover:!bg-[#166A45] lg:active:!bg-[#104631] lg:!text-white lg:focus-visible:ring-2 lg:focus-visible:ring-[#161616]" : ""),
                "aria-haspopup": "true",
                "aria-expanded": isOpen,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "flex items-center gap-[8px] hover:underline cursor-pointer select-none",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_icons_language_icon__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                className: "w-4 h-4 xl:w-6 xl:h-6 color-[currentColor]"
                            }),
                            labels.trigger
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(isOpen ? "rotate-180" : "rotate-0", " transition-all duration-200"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "md:block hidden",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M5.5031 7.1294C5.60467 7.26388 5.90793 7.66534 6.08853 7.89676C6.45026 8.36027 6.94452 8.97618 7.47769 9.59026C8.01356 10.2074 8.57648 10.8085 9.07658 11.2504C9.32734 11.472 9.54762 11.6403 9.72939 11.7499C9.90035 11.853 10.0013 11.8744 10.0013 11.8744C10.0013 11.8744 10.0994 11.853 10.2703 11.7499C10.4521 11.6403 10.6724 11.472 10.9231 11.2504C11.4232 10.8085 11.9861 10.2074 12.522 9.59025C13.0552 8.97616 13.5494 8.36025 13.9112 7.89673C14.0918 7.66531 14.3946 7.26442 14.4962 7.12994C14.7009 6.852 15.0925 6.79206 15.3705 6.99675C15.6484 7.20145 15.7078 7.59269 15.5031 7.87063L15.5015 7.87273C15.395 8.01376 15.0809 8.42963 14.8966 8.66577C14.5267 9.13975 14.018 9.77384 13.4659 10.4098C12.9165 11.0426 12.3117 11.6915 11.7508 12.1871C11.471 12.4343 11.1875 12.6566 10.9157 12.8204C10.661 12.9739 10.3386 13.125 9.99985 13.125C9.66109 13.125 9.33868 12.9739 9.08404 12.8204C8.81223 12.6566 8.52866 12.4343 8.24891 12.1871C7.68798 11.6915 7.08325 11.0426 6.53382 10.4098C5.98169 9.77386 5.473 9.13978 5.1031 8.6658C4.91871 8.42953 4.60464 8.01371 4.4983 7.87292L4.4969 7.87107C4.2922 7.59313 4.35128 7.20149 4.62922 6.99679C4.90714 6.7921 5.2984 6.85149 5.5031 7.1294Z",
                                        fill: "currentColor"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "md:hidden block",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M5.5031 7.1294C5.60467 7.26388 5.90793 7.66534 6.08853 7.89676C6.45026 8.36027 6.94452 8.97618 7.47769 9.59026C8.01356 10.2074 8.57648 10.8085 9.07658 11.2504C9.32734 11.472 9.54762 11.6403 9.72939 11.7499C9.90035 11.853 10.0013 11.8744 10.0013 11.8744C10.0013 11.8744 10.0994 11.853 10.2703 11.7499C10.4521 11.6403 10.6724 11.472 10.9231 11.2504C11.4232 10.8085 11.9861 10.2074 12.522 9.59025C13.0552 8.97616 13.5494 8.36025 13.9112 7.89673C14.0918 7.66531 14.3946 7.26442 14.4962 7.12994C14.7009 6.852 15.0925 6.79206 15.3705 6.99675C15.6484 7.20145 15.7078 7.59269 15.5031 7.87063L15.5015 7.87273C15.395 8.01376 15.0809 8.42963 14.8966 8.66577C14.5267 9.13975 14.018 9.77384 13.4659 10.4098C12.9165 11.0426 12.3117 11.6915 11.7508 12.1871C11.471 12.4343 11.1875 12.6566 10.9157 12.8204C10.661 12.9739 10.3386 13.125 9.99985 13.125C9.66109 13.125 9.33868 12.9739 9.08404 12.8204C8.81223 12.6566 8.52866 12.4343 8.24891 12.1871C7.68798 11.6915 7.08325 11.0426 6.53382 10.4098C5.98169 9.77386 5.473 9.13978 5.1031 8.6658C4.91871 8.42953 4.60464 8.01371 4.4983 7.87292L4.4969 7.87107C4.2922 7.59313 4.35128 7.20149 4.62922 6.99679C4.90714 6.7921 5.2984 6.85149 5.5031 7.1294Z",
                                        fill: "black"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "hidden lg:block absolute bottom-0 left-1/2 transform -translate-x-1/2 h-[6px] w-[86.89%] rounded-full z-30 transition-colors ".concat(isOpen ? "visible bg-[#54C08A]" : "invisible group-hover:visible group-hover:bg-[#9DA4AE] group-active:bg-[#1F2A37]")
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: onOverlayClick,
                        className: "hidden lg:block fixed bg-transparent inset-0 z-40",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_7__/* .Transition */ .u, {
                        as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
                        show: isOpen,
                        enter: "transition ease-out duration-200",
                        enterFrom: "opacity-0 translate-y-2",
                        enterTo: "opacity-100 translate-y-0",
                        leave: "transition ease-in duration-150",
                        leaveFrom: "opacity-100 translate-y-0",
                        leaveTo: "opacity-0 translate-y-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative lg:absolute mt-1 ".concat(isRtl ? "origin-top-left left-0" : "origin-top-right right-0", " lg:shadow-md rounded-lg w-[90vw] lg:w-48 lg:bg-white text-black focus:outline-none z-50"),
                            role: "menu",
                            "aria-orientation": "vertical",
                            "aria-labelledby": "language-menu-button",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "p-0 lg:p-4 flex flex-col gap-2",
                                children: labels.options.map(function(opt, index) {
                                    var localeCode = opt.href.replace("/", "");
                                    var isUnsupported = unSupportedLocales.includes(localeCode);
                                    var isCurrent = currentLocale === localeCode;
                                    return isUnsupported ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "\n                      text-start text-sm xl:text-base font-medium p-2 rounded w-full transition-colors flex items-center justify-between\n                      cursor-default\n                      ".concat(isCurrent ? "text-primary-600 font-semibold bg-neutral-50" : "", "\n                    "),
                                        role: "menuitem",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "flex items-center gap-2 opacity-30",
                                                children: opt.label
                                            }),
                                            opt.unsupportedText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "relative group ml-2",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_8__/* .HiOutlineExclamationCircle */ .baL, {
                                                        size: 18,
                                                        className: "text-red-500",
                                                        "aria-hidden": "true"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_7__/* .Transition */ .u, {
                                                        as: "div",
                                                        show: true,
                                                        enter: "transition ease-out duration-200",
                                                        enterFrom: "opacity-0 translate-y-1",
                                                        enterTo: "opacity-100 translate-y-0",
                                                        leave: "transition ease-in duration-150",
                                                        leaveFrom: "opacity-100 translate-y-0",
                                                        leaveTo: "opacity-0 translate-y-1",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "absolute z-50 ".concat(isRtl ? "left-full" : "right-full", "  top-6 w-max max-w-[200px] bg-white text-red-600 text-xs font-medium px-3 py-2 rounded shadow-md hidden group-hover:block whitespace-normal"),
                                                            children: opt.unsupportedText
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: router.asPath,
                                        locale: localeCode,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            onClick: function() {
                                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(e) {
                                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                                                        e.preventDefault();
                                                        setIsOpen(false);
                                                        (0,lib_switchLocale__WEBPACK_IMPORTED_MODULE_6__/* .switchLocale */ .K)(currentLocale, localeCode);
                                                        return [
                                                            2
                                                        ];
                                                    });
                                                });
                                                return function(e) {
                                                    return _ref.apply(this, arguments);
                                                };
                                            }(),
                                            className: "\n                          text-start text-sm xl:text-base font-medium p-2 rounded w-full transition-colors cursor-pointer flex items-center justify-between\n                          hover:bg-neutral-100\n                          ".concat(isCurrent ? "text-primary-600 font-semibold bg-neutral-50" : "", "\n                        "),
                                            role: "menuitem",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: opt.label
                                            })
                                        })
                                    }, index);
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LanguagesDropdown_DGA);


/***/ }),

/***/ 42681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lib_dgaGrayscaleMode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59573);
/* harmony import */ var lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85132);
/* harmony import */ var components_Feature_Navigation_HeaderNavigations_DGASecondNav_headerSecondNavI18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98701);
/* harmony import */ var components_Feature_Navigation_HeaderNavigations_DGASecondNav_useHeaderSecondNavGeo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38573);
/**
 * DGA utility row under the stamp: weather, local date/time, location (from GPS + APIs when allowed),
 * and a toolbar for root font zoom + grayscale contrast (shared with the footer).
 */ 





var ICON_FILL = "#384250";
/** Figma action toolbar glyphs (voice / zoom / contrast, #161616). */ var ACTION_TOOLBAR_ICON_FILL = "#161616";
/** Matches Figma `Second Nav Header` / Actions: 32×32 control, 20×20 asset, `radius-sm`, no extra wrappers. */ var ACTION_BTN_CLASS = "flex h-8 w-8 min-h-8 min-w-8 max-h-8 max-w-8 shrink-0 items-center justify-center overflow-hidden rounded p-0 transition-colors hover:bg-neutral-200/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 disabled:pointer-events-none disabled:opacity-40";
// --- Root font zoom (html { font-size: N% }, persisted in sessionStorage) ---
var ZOOM_STORAGE_KEY = "dga-root-font-zoom-pct";
var DEFAULT_ZOOM_PCT = 100;
var MIN_ZOOM_PCT = 80;
var MAX_ZOOM_PCT = 120;
var ZOOM_STEP_PCT = 5;
function applyRootFontZoom(pct) {
    var clamped = Math.min(MAX_ZOOM_PCT, Math.max(MIN_ZOOM_PCT, pct));
    document.documentElement.style.fontSize = "".concat(clamped, "%");
    try {
        sessionStorage.setItem(ZOOM_STORAGE_KEY, String(clamped));
    } catch (e) {
    /* quota / private mode */ }
    return clamped;
}
function readStoredZoom() {
    if (false) {}
    try {
        var s = sessionStorage.getItem(ZOOM_STORAGE_KEY);
        if (s) {
            var n = parseInt(s, 10);
            if (!Number.isNaN(n)) return Math.min(MAX_ZOOM_PCT, Math.max(MIN_ZOOM_PCT, n));
        }
    } catch (e) {
    /* access denied */ }
    return DEFAULT_ZOOM_PCT;
}
// --- Date/time strings (no commas; safe for screen readers) ---
/** Removes locale commas (e.g. US "Sep 3, 2026"); uses hyphens between parts for LTR locales. */ function formatNavDate(d, locale) {
    var loc = (0,lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeLocale */ .R7)(locale);
    var raw = d.toLocaleDateString(loc, {
        day: "numeric",
        month: "short",
        year: "numeric"
    });
    var noComma = raw.replace(/,/g, "").trim();
    var isArabic = loc.toLowerCase().startsWith("ar");
    var normalized = isArabic ? noComma.replace(/\s+/g, " ") : noComma.replace(/\s+/g, "-");
    return (0,lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeDisplayText */ .Me)(normalized, 64);
}
function formatNavTime(d, locale) {
    var loc = (0,lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeLocale */ .R7)(locale);
    var raw = d.toLocaleTimeString(loc, {
        hour: "numeric",
        minute: "2-digit"
    });
    return (0,lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeDisplayText */ .Me)(raw.replace(/,/g, "").trim(), 32);
}
// --- Small presentational pieces (icons, row item, toolbar) ---
/** Same box + SVG scale as context icons (20×20 glyph in 24×24 cell). */ var NAV_ICON_CELL = "relative flex h-6 w-6 shrink-0 items-center justify-center [&_svg]:h-5 [&_svg]:w-5";
var SecondNavInlineSpinner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "inline-block h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-neutral-400 border-t-primary-600",
        role: "status",
        "aria-hidden": "true"
    });
};
var SecondNavItem = function(param) {
    var icon = param.icon, visibleLabel = param.visibleLabel, groupAriaLabel = param.groupAriaLabel, isLoading = param.isLoading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: "list-none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex min-w-0 items-center gap-1",
            role: "group",
            "aria-label": groupAriaLabel,
            "aria-busy": isLoading ? true : undefined,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: NAV_ICON_CELL,
                    "aria-hidden": "true",
                    children: icon
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "flex min-h-6 min-w-[1.25rem] items-center whitespace-nowrap text-base font-normal leading-6 text-neutral-700",
                    children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SecondNavInlineSpinner, {}) : visibleLabel
                })
            ]
        })
    });
};
var IconCloud = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 24 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.14 3.39C6.52 4.43 6.5 5.72 6.5 6.75C6.5 7.16 6.16 7.5 5.75 7.5C5.04 7.5 3.95 7.72 3.06 8.36C2.21 8.97 1.5 9.99 1.5 11.75C1.5 13.51 2.21 14.53 3.06 15.14C3.95 15.78 5.04 16 5.75 16H17.75C18.46 16 19.55 15.78 20.44 15.14C21.29 14.53 22 13.51 22 11.75C22 9.99 21.29 8.97 20.44 8.36C19.55 7.72 18.46 7.5 17.75 7.5C17.34 7.5 17 7.16 17 6.75C17 5.72 16.98 4.43 16.36 3.39C15.78 2.42 14.57 1.5 11.75 1.5C8.93 1.5 7.72 2.42 7.14 3.39ZM5.86 2.61C6.78 1.08 8.57 0 11.75 0C14.93 0 16.72 1.08 17.64 2.61C18.33 3.76 18.47 5.07 18.49 6.05C19.36 6.16 20.4 6.48 21.31 7.14C22.55 8.03 23.5 9.51 23.5 11.75C23.5 13.99 22.55 15.47 21.31 16.36C20.12 17.22 18.7 17.5 17.75 17.5H5.75C4.8 17.5 3.38 17.22 2.19 16.36C0.95 15.47 0 13.99 0 11.75C0 9.51 0.95 8.03 2.19 7.14C3.1 6.48 4.14 6.16 5.01 6.05C5.03 5.07 5.17 3.76 5.86 2.61Z",
            fill: ICON_FILL
        })
    });
};
/** Calendar icon only (no English wordmark — real date is shown beside the icon). */ var IconCalendar = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7 1.75C7.41421 1.75 7.75 2.08579 7.75 2.5V6.5C7.75 6.91421 7.41421 7.25 7 7.25C6.58579 7.25 6.25 6.91421 6.25 6.5V5.25H5C4.30964 5.25 3.75 5.80964 3.75 6.5V9.75H20.25V6.5C20.25 5.80964 19.6904 5.25 19 5.25H18.5C18.0858 5.25 17.75 4.91421 17.75 4.5C17.75 4.08579 18.0858 3.75 18.5 3.75H19C20.5188 3.75 21.75 4.98122 21.75 6.5V19.5C21.75 21.0188 20.5188 22.25 19 22.25H5C3.48122 22.25 2.25 21.0188 2.25 19.5V6.5C2.25 4.98122 3.48122 3.75 5 3.75H6.25V2.5C6.25 2.08579 6.58579 1.75 7 1.75ZM3.75 19.5C3.75 20.1904 4.30964 20.75 5 20.75H19C19.6904 20.75 20.25 20.1904 20.25 19.5V11.25H3.75V19.5Z",
                fill: ICON_FILL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15 1.75C15.4142 1.75 15.75 2.08579 15.75 2.5V6.5C15.75 6.91421 15.4142 7.25 15 7.25C14.5858 7.25 14.25 6.91421 14.25 6.5V5.25H10.5C10.0858 5.25 9.75 4.91421 9.75 4.5C9.75 4.08579 10.0858 3.75 10.5 3.75H14.25V2.5C14.25 2.08579 14.5858 1.75 15 1.75Z",
                fill: ICON_FILL
            })
        ]
    });
};
var IconClock = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                stroke: ICON_FILL,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12 6V12H16.5",
                stroke: ICON_FILL,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/** Zoom out (Figma SVG, 20×20 in 32×32 control). */ var IconZoomOut = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        className: "pointer-events-none block shrink-0 select-none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1.63416 12.7038C1.97582 12.6871 2.27582 12.9538 2.29249 13.2954C2.38416 15.1121 2.65082 16.0454 3.29249 16.6788C4.02582 17.4121 5.14249 17.6454 7.50082 17.7038C7.84249 17.7038 8.11749 17.9954 8.10915 18.3454C8.10915 18.6871 7.81749 18.9621 7.46749 18.9538C5.15082 18.9038 3.53416 18.6954 2.40082 17.5621C1.40916 16.5704 1.13416 15.2121 1.04249 13.3621C1.02582 13.0204 1.29249 12.7204 1.63416 12.7038Z",
                fill: ACTION_TOOLBAR_ICON_FILL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18.3675 12.7038C18.7092 12.7204 18.9758 13.0121 18.9592 13.3621C18.8675 15.2121 18.5925 16.5788 17.5925 17.5704C16.4592 18.6954 14.8425 18.9038 12.5258 18.9621C12.1842 18.9621 11.8925 18.6954 11.8842 18.3538C11.8842 18.0121 12.1508 17.7204 12.4925 17.7121C14.8508 17.6621 15.9675 17.4204 16.7008 16.6871C17.3425 16.0538 17.6092 15.1204 17.7008 13.3038C17.7175 12.9621 18.0092 12.6954 18.3592 12.7121L18.3675 12.7038Z",
                fill: ACTION_TOOLBAR_ICON_FILL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.58416 5.20378C12.0008 5.20378 13.9592 7.16211 13.9592 9.57878C13.9592 10.5621 13.6342 11.4704 13.0842 12.1954L14.6092 13.7204C14.8508 13.9621 14.8508 14.3621 14.6092 14.6038C14.3675 14.8454 13.9675 14.8454 13.7258 14.6038L12.2008 13.0788C11.4675 13.6288 10.5592 13.9454 9.58416 13.9454C7.16749 13.9454 5.20916 11.9871 5.20916 9.57044C5.20916 7.15378 7.16749 5.19544 9.58416 5.19544V5.20378ZM9.58416 6.45378C7.85916 6.45378 6.45916 7.85378 6.45916 9.57878C6.45916 11.3038 7.85916 12.7038 9.58416 12.7038C11.3092 12.7038 12.7092 11.3038 12.7092 9.57878C12.7092 7.85378 11.3092 6.45378 9.58416 6.45378Z",
                fill: ACTION_TOOLBAR_ICON_FILL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.47582 1.03711C7.81749 1.03711 8.10915 1.30378 8.11749 1.64544C8.11749 1.98711 7.85082 2.27878 7.50916 2.28711C5.15082 2.33711 4.03416 2.57878 3.30082 3.31211C2.65916 3.94544 2.39249 4.87878 2.30082 6.69544C2.28416 7.03711 1.99249 7.30378 1.64249 7.28711C1.30082 7.27044 1.03416 6.97878 1.05082 6.62878C1.13416 4.77878 1.40916 3.42044 2.40916 2.42878C3.54249 1.29544 5.15915 1.08711 7.47582 1.03711Z",
                fill: ACTION_TOOLBAR_ICON_FILL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.5258 1.03711C14.8425 1.08711 16.4592 1.29544 17.5925 2.42878C18.5925 3.42044 18.8675 4.77878 18.9592 6.63711C18.9758 6.97878 18.7092 7.27878 18.3675 7.29544C18.0258 7.31211 17.7258 7.04544 17.7092 6.70378C17.6175 4.88711 17.3508 3.95378 16.7092 3.32044C15.9758 2.58711 14.8592 2.35378 12.5008 2.29544C12.1592 2.29544 11.8842 2.00378 11.8925 1.65378C11.8925 1.31211 12.1842 1.03711 12.5342 1.04544L12.5258 1.03711Z",
                fill: ACTION_TOOLBAR_ICON_FILL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.82582 8.95378C7.48416 8.95378 7.20082 9.23711 7.20082 9.57878C7.20082 9.92044 7.48416 10.2038 7.82582 10.2038H11.0758C11.4175 10.2038 11.7008 9.92044 11.7008 9.57878C11.7008 9.23711 11.4175 8.95378 11.0758 8.95378H7.82582Z",
                fill: ACTION_TOOLBAR_ICON_FILL
            })
        ]
    });
};
/** Zoom in (Figma SVG, 20×20 in 32×32 control). */ var IconZoomIn = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        className: "pointer-events-none block shrink-0 select-none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1.63416 12.7038C1.97582 12.6871 2.27582 12.9538 2.29249 13.2954C2.38416 15.1121 2.65082 16.0454 3.29249 16.6788C4.02582 17.4121 5.14249 17.6454 7.50082 17.7038C7.84249 17.7038 8.11749 17.9954 8.10915 18.3454C8.10915 18.6871 7.81749 18.9621 7.46749 18.9538C5.15082 18.9038 3.53416 18.6954 2.40082 17.5621C1.40916 16.5704 1.13416 15.2121 1.04249 13.3621C1.02582 13.0204 1.29249 12.7204 1.63416 12.7038Z",
                fill: ACTION_TOOLBAR_ICON_FILL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18.3675 12.7038C18.7092 12.7204 18.9758 13.0121 18.9592 13.3621C18.8675 15.2121 18.5925 16.5788 17.5925 17.5704C16.4592 18.6954 14.8425 18.9038 12.5258 18.9621C12.1842 18.9621 11.8925 18.6954 11.8842 18.3538C11.8842 18.0121 12.1508 17.7204 12.4925 17.7121C14.8508 17.6621 15.9675 17.4204 16.7008 16.6871C17.3425 16.0538 17.6092 15.1204 17.7008 13.3038C17.7175 12.9621 18.0092 12.6954 18.3592 12.7121L18.3675 12.7038Z",
                fill: ACTION_TOOLBAR_ICON_FILL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.58416 5.20378C12.0008 5.20378 13.9592 7.16211 13.9592 9.57878C13.9592 10.5621 13.6342 11.4704 13.0842 12.1954L14.6092 13.7204C14.8508 13.9621 14.8508 14.3621 14.6092 14.6038C14.3675 14.8454 13.9675 14.8454 13.7258 14.6038L12.2008 13.0788C11.4675 13.6288 10.5592 13.9454 9.58416 13.9454C7.16749 13.9454 5.20916 11.9871 5.20916 9.57044C5.20916 7.15378 7.16749 5.19544 9.58416 5.19544V5.20378ZM9.58416 6.45378C7.85916 6.45378 6.45916 7.85378 6.45916 9.57878C6.45916 11.3038 7.85916 12.7038 9.58416 12.7038C11.3092 12.7038 12.7092 11.3038 12.7092 9.57878C12.7092 7.85378 11.3092 6.45378 9.58416 6.45378Z",
                fill: ACTION_TOOLBAR_ICON_FILL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.47582 1.03711C7.81749 1.03711 8.10915 1.30378 8.11749 1.64544C8.11749 1.98711 7.85082 2.27878 7.50916 2.28711C5.15082 2.33711 4.03416 2.57878 3.30082 3.31211C2.65916 3.94544 2.39249 4.87878 2.30082 6.69544C2.28416 7.03711 1.99249 7.30378 1.64249 7.28711C1.30082 7.27044 1.03416 6.97878 1.05082 6.62878C1.13416 4.77878 1.40916 3.42044 2.40916 2.42878C3.54249 1.29544 5.15915 1.08711 7.47582 1.03711Z",
                fill: ACTION_TOOLBAR_ICON_FILL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.5258 1.03711C14.8425 1.08711 16.4592 1.29544 17.5925 2.42878C18.5925 3.42044 18.8675 4.77878 18.9592 6.63711C18.9758 6.97878 18.7092 7.27878 18.3675 7.29544C18.0258 7.31211 17.7258 7.04544 17.7092 6.70378C17.6175 4.88711 17.3508 3.95378 16.7092 3.32044C15.9758 2.58711 14.8592 2.35378 12.5008 2.29544C12.1592 2.29544 11.8842 2.00378 11.8925 1.65378C11.8925 1.31211 12.1842 1.03711 12.5342 1.04544L12.5258 1.03711Z",
                fill: ACTION_TOOLBAR_ICON_FILL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9.58416 7.47878C9.25916 7.47878 9.00082 7.73711 9.00082 8.06211V8.99544H8.06749C7.74249 8.99544 7.48416 9.25378 7.48416 9.57878C7.48416 9.90378 7.74249 10.1621 8.06749 10.1621H9.00082V11.0954C9.00082 11.4204 9.25916 11.6788 9.58416 11.6788C9.90915 11.6788 10.1675 11.4204 10.1675 11.0954V10.1621H11.1008C11.4258 10.1621 11.6842 9.90378 11.6842 9.57878C11.6842 9.25378 11.4258 8.99544 11.1008 8.99544H10.1675V8.06211C10.1675 7.73711 9.90915 7.47878 9.58416 7.47878Z",
                fill: ACTION_TOOLBAR_ICON_FILL
            })
        ]
    });
};
/** Contrast / view (Figma SVG, eye — 20×20 in 32×32 control). */ var IconContrastView = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        className: "pointer-events-none block shrink-0 select-none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.9302 11.0895C14.1513 4.91418 5.84899 4.91418 3.07011 11.0895C2.92846 11.4043 2.55845 11.5446 2.24368 11.403C1.9289 11.2613 1.78855 10.8913 1.9302 10.5765C5.15132 3.4185 14.849 3.4185 18.0701 10.5765C18.2118 10.8913 18.0714 11.2613 17.7566 11.403C17.4419 11.5446 17.0719 11.4043 16.9302 11.0895Z",
                fill: ACTION_TOOLBAR_ICON_FILL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.0002 9.79134C11.0357 9.79134 11.8752 10.6308 11.8752 11.6663C11.8752 12.7019 11.0357 13.5413 10.0002 13.5413C8.96462 13.5413 8.12515 12.7019 8.12515 11.6663C8.12515 10.6308 8.96462 9.79134 10.0002 9.79134ZM13.1252 11.6663C13.1252 9.94045 11.726 8.54134 10.0002 8.54134C8.27426 8.54134 6.87515 9.94045 6.87515 11.6663C6.87515 13.3922 8.27426 14.7913 10.0002 14.7913C11.726 14.7913 13.1252 13.3922 13.1252 11.6663Z",
                fill: ACTION_TOOLBAR_ICON_FILL
            })
        ]
    });
};
/** Voice input (Figma SVG, mic — 20×20 in 32×32 control). */ // const IconVoice = (): JSX.Element => (
//   <svg
//     width={20}
//     height={20}
//     viewBox="0 0 20 20"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//     aria-hidden="true"
//     focusable="false"
//     className="pointer-events-none block shrink-0 select-none"
//   >
//     <path
//       d="M15.8334 7.70866C16.1786 7.70866 16.4584 7.98848 16.4584 8.33366V9.16699C16.4584 12.523 13.8986 15.28 10.6251 15.5944V17.7087H12.5001C12.8453 17.7087 13.1251 17.9885 13.1251 18.3337C13.1251 18.6788 12.8453 18.9587 12.5001 18.9587H7.50008C7.1549 18.9587 6.87508 18.6788 6.87508 18.3337C6.87508 17.9885 7.1549 17.7087 7.50008 17.7087H9.37508V15.5944C6.10155 15.28 3.54175 12.523 3.54175 9.16699V8.33366C3.54175 7.98848 3.82157 7.70866 4.16675 7.70866C4.51193 7.70866 4.79175 7.98848 4.79175 8.33366V9.16699C4.79175 12.0435 7.1236 14.3753 10.0001 14.3753C12.8766 14.3753 15.2084 12.0435 15.2084 9.16699V8.33366C15.2084 7.98848 15.4882 7.70866 15.8334 7.70866Z"
//       fill={ACTION_TOOLBAR_ICON_FILL}
//     />
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M10.0001 1.04199C11.726 1.04199 13.1251 2.4411 13.1251 4.16699V9.16699C13.1251 10.8929 11.726 12.292 10.0001 12.292C8.27419 12.292 6.87508 10.8929 6.87508 9.16699V4.16699C6.87508 2.4411 8.27419 1.04199 10.0001 1.04199ZM10.0001 2.29199C8.96455 2.29199 8.12508 3.13146 8.12508 4.16699V9.16699C8.12508 10.2025 8.96455 11.042 10.0001 11.042C11.0356 11.042 11.8751 10.2025 11.8751 9.16699V4.16699C11.8751 3.13146 11.0356 2.29199 10.0001 2.29199Z"
//       fill={ACTION_TOOLBAR_ICON_FILL}
//     />
//   </svg>
// );
/** Map pin only (no English wordmark — place name is shown beside the icon). */ var IconLocation = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.001 8.10938C12.9675 8.10938 13.751 8.89288 13.751 9.85938C13.751 10.8259 12.9675 11.6094 12.001 11.6094C11.0345 11.6094 10.251 10.8259 10.251 9.85938C10.251 8.89288 11.0345 8.10938 12.001 8.10938Z",
                fill: ICON_FILL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.001 1.10938C16.8335 1.10938 20.751 5.02688 20.751 9.85938C20.751 11.1611 20.1722 12.6018 19.4043 13.9658C18.625 15.35 17.5962 16.75 16.582 17.9912C15.5656 19.2352 14.5513 20.3365 13.792 21.126C13.4121 21.521 13.0948 21.8387 12.8721 22.0586C12.7608 22.1684 12.6727 22.2541 12.6123 22.3125L12.542 22.3799L12.5244 22.3975L12.5186 22.4014L12.5176 22.4033L12.001 22.8926L11.4844 22.4033L11.4775 22.3975L11.46 22.3799L11.3896 22.3125C11.3292 22.2541 11.2412 22.1684 11.1299 22.0586C10.9071 21.8387 10.5899 21.521 10.21 21.126C9.45069 20.3365 8.43635 19.2352 7.41992 17.9912C6.40577 16.75 5.37699 15.35 4.59766 13.9658C3.82972 12.6018 3.25098 11.1611 3.25098 9.85938C3.25098 5.02688 7.16848 1.10938 12.001 1.10938ZM12.001 2.60938C7.99691 2.60938 4.75098 5.85531 4.75098 9.85938C4.75098 10.7667 5.17232 11.9304 5.9043 13.2305C6.62496 14.5105 7.59618 15.8355 8.58203 17.042C9.56548 18.2456 10.5514 19.3159 11.292 20.0859C11.5669 20.3718 11.8074 20.6161 12.001 20.8096C12.1946 20.6161 12.435 20.3718 12.71 20.0859C13.4506 19.3159 14.4365 18.2456 15.4199 17.042C16.4058 15.8355 17.377 14.5105 18.0977 13.2305C18.8296 11.9304 19.251 10.7667 19.251 9.85938C19.251 5.85531 16.005 2.60938 12.001 2.60938Z",
                fill: ICON_FILL
            })
        ]
    });
};
var HeaderDGASecondNavBar = function(param) {
    var _fallbackLocationLabel = param.fallbackLocationLabel, fallbackLocationLabel = _fallbackLocationLabel === void 0 ? "" : _fallbackLocationLabel, localeProp = param.locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        return new Date();
    }), now = ref[0], setNow = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        return (0,lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeLocale */ .R7)(localeProp !== null && localeProp !== void 0 ? localeProp : typeof navigator !== "undefined" ? navigator.language : "en-GB");
    }), resolvedLocale = ref1[0], setResolvedLocale = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(DEFAULT_ZOOM_PCT), zoomPct = ref2[0], setZoomPct = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isGrayscale = ref3[0], setIsGrayscale = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var fromBrowser = typeof navigator !== "undefined" ? navigator.language : "en-GB";
        setResolvedLocale((0,lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeLocale */ .R7)(localeProp !== null && localeProp !== void 0 ? localeProp : fromBrowser));
    }, [
        localeProp
    ]);
    var ref4 = (0,components_Feature_Navigation_HeaderNavigations_DGASecondNav_useHeaderSecondNavGeo__WEBPACK_IMPORTED_MODULE_3__.useHeaderSecondNavGeo)({
        resolvedLocale: resolvedLocale,
        fallbackLocationLabel: fallbackLocationLabel
    }), weatherCode = ref4.weatherCode, locationLabel = ref4.locationLabel, showGeoRows = ref4.showGeoRows, geoRowsLoading = ref4.geoRowsLoading;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var id = window.setInterval(function() {
            return setNow(new Date());
        }, 60000);
        return function() {
            return window.clearInterval(id);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var z = readStoredZoom();
        setZoomPct(z);
        applyRootFontZoom(z);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsGrayscale((0,lib_dgaGrayscaleMode__WEBPACK_IMPORTED_MODULE_5__/* .getGrayscaleModeEnabled */ .l)());
        var onChange = function() {
            return setIsGrayscale((0,lib_dgaGrayscaleMode__WEBPACK_IMPORTED_MODULE_5__/* .getGrayscaleModeEnabled */ .l)());
        };
        window.addEventListener(lib_dgaGrayscaleMode__WEBPACK_IMPORTED_MODULE_5__/* .DGA_GRAYSCALE_CHANGE_EVENT */ .pf, onChange);
        return function() {
            return window.removeEventListener(lib_dgaGrayscaleMode__WEBPACK_IMPORTED_MODULE_5__/* .DGA_GRAYSCALE_CHANGE_EVENT */ .pf, onChange);
        };
    }, []);
    var messages = (0,components_Feature_Navigation_HeaderNavigations_DGASecondNav_headerSecondNavI18n__WEBPACK_IMPORTED_MODULE_2__.getSecondNavMessages)(resolvedLocale);
    var dateLabel = formatNavDate(now, resolvedLocale);
    var timeLabel = formatNavTime(now, resolvedLocale);
    var weatherDisplay = weatherCode !== null ? (0,lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeDisplayText */ .Me)((0,components_Feature_Navigation_HeaderNavigations_DGASecondNav_headerSecondNavI18n__WEBPACK_IMPORTED_MODULE_2__.weatherCodeToLabel)(weatherCode, resolvedLocale), 64) : messages.unavailable;
    var locationSanitized = (0,lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeDisplayText */ .Me)(locationLabel, 120);
    var locationDisplay = locationSanitized.length > 0 && locationSanitized !== "—" ? locationSanitized : messages.unavailable;
    var zoomOut = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setZoomPct(function(z) {
            return applyRootFontZoom(z - ZOOM_STEP_PCT);
        });
    }, []);
    var zoomIn = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setZoomPct(function(z) {
            return applyRootFontZoom(z + ZOOM_STEP_PCT);
        });
    }, []);
    var toggleContrast = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setIsGrayscale((0,lib_dgaGrayscaleMode__WEBPACK_IMPORTED_MODULE_5__/* .toggleGrayscaleMode */ .b6)());
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "border-t border-b border-neutral-300 bg-neutral-100",
        "aria-label": messages.a11y.section,
        "aria-busy": geoRowsLoading,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "responsive flex h-auto min-h-10 flex-wrap items-center justify-between gap-x-4 gap-y-2 py-2 md:h-10 md:py-0",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    className: "m-0 flex min-w-0 list-none flex-wrap items-center gap-4 p-0",
                    "aria-label": messages.a11y.contextList,
                    children: [
                        showGeoRows && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SecondNavItem, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconCloud, {}),
                            visibleLabel: weatherDisplay,
                            groupAriaLabel: geoRowsLoading ? messages.a11y.loadingWeather : "".concat(messages.a11y.weather, ", ").concat(weatherDisplay),
                            isLoading: geoRowsLoading
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SecondNavItem, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconCalendar, {}),
                            visibleLabel: dateLabel,
                            groupAriaLabel: "".concat(messages.a11y.date, ", ").concat(dateLabel)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SecondNavItem, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconClock, {}),
                            visibleLabel: timeLabel,
                            groupAriaLabel: "".concat(messages.a11y.time, ", ").concat(timeLabel)
                        }),
                        showGeoRows && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SecondNavItem, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconLocation, {}),
                            visibleLabel: locationDisplay,
                            groupAriaLabel: geoRowsLoading ? messages.a11y.loadingLocation : "".concat(messages.a11y.location, ", ").concat(locationDisplay),
                            isLoading: geoRowsLoading
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center gap-1.5",
                    role: "toolbar",
                    "aria-label": messages.a11y.toolbar,
                    "aria-orientation": "horizontal",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            className: ACTION_BTN_CLASS,
                            "aria-label": "".concat(messages.a11y.zoomOut, ". ").concat(messages.zoomWithPercent(zoomPct)),
                            onClick: zoomOut,
                            disabled: zoomPct <= MIN_ZOOM_PCT,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconZoomOut, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            className: ACTION_BTN_CLASS,
                            "aria-label": "".concat(messages.a11y.zoomIn, ". ").concat(messages.zoomWithPercent(zoomPct)),
                            onClick: zoomIn,
                            disabled: zoomPct >= MAX_ZOOM_PCT,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconZoomIn, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            className: ACTION_BTN_CLASS,
                            "aria-label": isGrayscale ? "".concat(messages.a11y.contrastOn, ". ").concat(messages.a11y.viewContrast) : "".concat(messages.a11y.contrastOff, ". ").concat(messages.a11y.viewContrast),
                            "aria-pressed": isGrayscale,
                            onClick: toggleContrast,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconContrastView, {})
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HeaderDGASecondNavBar);


/***/ }),

/***/ 76229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/**
 * Lightweight placeholder while the second-nav chunk loads (dynamic import from HeaderNavigation_DGA).
 * Matches layout/height of the real bar to limit CLS.
 */ 
var HeaderDGASecondNavBarSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "border-t border-b border-neutral-300 bg-neutral-100",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "responsive flex h-auto min-h-10 flex-wrap items-center justify-between gap-x-4 gap-y-2 py-2 md:h-10 md:py-0",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-6 max-w-[min(100%,28rem)] min-w-0 flex-1 animate-pulse rounded bg-neutral-200/80"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex h-8 shrink-0 items-center gap-1.5",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "h-8 w-8 rounded bg-neutral-200/80"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "h-8 w-8 rounded bg-neutral-200/80"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "h-8 w-8 rounded bg-neutral-200/80"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HeaderDGASecondNavBarSkeleton);


/***/ }),

/***/ 98701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getGeocodeLanguageCode": function() { return /* binding */ getGeocodeLanguageCode; },
/* harmony export */   "getSecondNavMessages": function() { return /* binding */ getSecondNavMessages; },
/* harmony export */   "weatherCodeToLabel": function() { return /* binding */ weatherCodeToLabel; }
/* harmony export */ });
/* harmony import */ var lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85132);

var EN = {
    unavailable: "—",
    a11y: {
        section: "Site utilities and accessibility",
        contextList: "Local date, time, weather, and location",
        toolbar: "Page display and contrast",
        weather: "Weather",
        date: "Date",
        time: "Time",
        location: "Location",
        zoomOut: "Decrease text size",
        zoomIn: "Increase text size",
        contrastOn: "Disable grayscale contrast mode",
        contrastOff: "Enable grayscale contrast mode",
        voiceInput: "Voice input",
        viewContrast: "Contrast and visibility",
        loadingWeather: "Loading weather",
        loadingLocation: "Loading location"
    },
    zoomWithPercent: function(pct) {
        return "Current size ".concat(pct, " percent");
    }
};
var AR = {
    unavailable: "—",
    a11y: {
        section: "خدمات الموقع وإمكانية الوصول",
        contextList: "التاريخ والوقت والطقس والموقع المحلي",
        toolbar: "عرض الصفحة والتباين",
        weather: "الطقس",
        date: "التاريخ",
        time: "الوقت",
        location: "الموقع",
        zoomOut: "تصغير حجم النص",
        zoomIn: "تكبير حجم النص",
        contrastOn: "إيقاف وضع التباين الرمادي",
        contrastOff: "تشغيل وضع التباين الرمادي",
        voiceInput: "إدخال صوتي",
        viewContrast: "التباين والرؤية",
        loadingWeather: "جاري تحميل الطقس",
        loadingLocation: "جاري تحميل الموقع"
    },
    zoomWithPercent: function(pct) {
        return "الحجم الحالي ".concat(pct, "٪");
    }
};
/** First segment of a locale tag, e.g. "ar-SA" → "ar". */ function primaryLanguage(locale) {
    var ref;
    var ref1;
    return (ref1 = (ref = (0,lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeLocale */ .R7)(locale).split("-")[0]) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== null && ref1 !== void 0 ? ref1 : "en";
}
/** BigDataCloud wants a two-letter ISO 639-1 code for place names language. */ function getGeocodeLanguageCode(locale) {
    var lang = primaryLanguage(locale);
    return /^[a-z]{2}$/.test(lang) ? lang : "en";
}
function getSecondNavMessages(locale) {
    return primaryLanguage(locale) === "ar" ? AR : EN;
}
var WEATHER_EN = {
    clear: "Clear",
    cloudy: "Cloudy",
    fog: "Fog",
    rain: "Rain",
    snow: "Snow",
    showers: "Showers",
    storm: "Storm"
};
var WEATHER_AR = {
    clear: "صافٍ",
    cloudy: "غائم",
    fog: "ضباب",
    rain: "مطر",
    snow: "ثلج",
    showers: "زخات مطر",
    storm: "عاصفة"
};
/**
 * Maps Open-Meteo / WMO weather codes to a short label.
 * Ranges follow common WMO groupings (clear, clouds, fog, rain, snow, showers, thunderstorm).
 */ function weatherCodeToLabel(code, locale) {
    var words = primaryLanguage(locale) === "ar" ? WEATHER_AR : WEATHER_EN;
    var key = "cloudy";
    if (code === 0) key = "clear";
    else if (code >= 1 && code <= 3) key = "cloudy";
    else if (code >= 45 && code <= 48) key = "fog";
    else if (code >= 51 && code <= 67) key = "rain";
    else if (code >= 71 && code <= 77) key = "snow";
    else if (code >= 80 && code <= 82) key = "showers";
    else if (code >= 95) key = "storm";
    return words[key];
}


/***/ }),

/***/ 21940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fetchWeatherCode": function() { return /* binding */ fetchWeatherCode; },
/* harmony export */   "reverseGeocodeCity": function() { return /* binding */ reverseGeocodeCity; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85132);



var FETCH_TIMEOUT_MS = 10000;
var WEATHER_CODE_MAX = 99;
function fetchJsonWithTimeout(url) {
    return _fetchJsonWithTimeout.apply(this, arguments);
}
function _fetchJsonWithTimeout() {
    _fetchJsonWithTimeout = /** GET JSON with a hard timeout; used only in the browser. */ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(url) {
        var ctrl, timer, res, ct, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (false) {}
                    ctrl = new AbortController();
                    timer = window.setTimeout(function() {
                        return ctrl.abort();
                    }, FETCH_TIMEOUT_MS);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        5,
                        6
                    ]);
                    return [
                        4,
                        fetch(url, {
                            signal: ctrl.signal,
                            credentials: "omit",
                            mode: "cors",
                            cache: "no-store"
                        })
                    ];
                case 2:
                    res = _state.sent();
                    if (!res.ok) return [
                        2,
                        null
                    ];
                    ct = res.headers.get("content-type");
                    if (ct && !ct.includes("json")) return [
                        2,
                        null
                    ];
                    return [
                        4,
                        res.json()
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 5:
                    window.clearTimeout(timer);
                    return [
                        7
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchJsonWithTimeout.apply(this, arguments);
}
/** City / region name for map coordinates (language from locale). */ function reverseGeocodeCity(lat, lng, localityLanguage) {
    return _reverseGeocodeCity.apply(this, arguments);
}
function _reverseGeocodeCity() {
    _reverseGeocodeCity = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(lat, lng, localityLanguage) {
        var latR, lngR, raw, lang, url, data, pick, sanitized;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(0,lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_2__/* .isValidCoordinates */ .OF)(lat, lng)) return [
                        2,
                        null
                    ];
                    latR = Math.round(lat * 1e6) / 1e6;
                    lngR = Math.round(lng * 1e6) / 1e6;
                    raw = localityLanguage.trim().toLowerCase().slice(0, 8);
                    lang = /^[a-z]{2}$/.test(raw) ? raw : "en";
                    url = "https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=".concat(encodeURIComponent(String(latR)), "&longitude=").concat(encodeURIComponent(String(lngR)), "&localityLanguage=").concat(encodeURIComponent(lang));
                    return [
                        4,
                        fetchJsonWithTimeout(url)
                    ];
                case 1:
                    data = _state.sent();
                    if (!data) return [
                        2,
                        null
                    ];
                    pick = [
                        data.city,
                        data.locality,
                        data.principalSubdivision
                    ].find(function(v) {
                        return typeof v === "string" && v.length > 0;
                    });
                    sanitized = (0,lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeDisplayText */ .Me)(pick, 120);
                    return [
                        2,
                        sanitized.length > 0 ? sanitized : null
                    ];
            }
        });
    });
    return _reverseGeocodeCity.apply(this, arguments);
}
/** WMO weather code from Open-Meteo “current weather”. */ function fetchWeatherCode(lat, lng) {
    return _fetchWeatherCode.apply(this, arguments);
}
function _fetchWeatherCode() {
    _fetchWeatherCode = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(lat, lng) {
        var ref, latR, lngR, url, data, code;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(0,lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_2__/* .isValidCoordinates */ .OF)(lat, lng)) return [
                        2,
                        null
                    ];
                    latR = Math.round(lat * 1e4) / 1e4;
                    lngR = Math.round(lng * 1e4) / 1e4;
                    url = "https://api.open-meteo.com/v1/forecast?latitude=".concat(encodeURIComponent(String(latR)), "&longitude=").concat(encodeURIComponent(String(lngR)), "&current_weather=true");
                    return [
                        4,
                        fetchJsonWithTimeout(url)
                    ];
                case 1:
                    data = _state.sent();
                    code = data === null || data === void 0 ? void 0 : (ref = data.current_weather) === null || ref === void 0 ? void 0 : ref.weathercode;
                    if (typeof code !== "number" || !Number.isFinite(code) || code < 0 || code > WEATHER_CODE_MAX) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        2,
                        Math.round(code)
                    ];
            }
        });
    });
    return _fetchWeatherCode.apply(this, arguments);
}


/***/ }),

/***/ 38573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useHeaderSecondNavGeo": function() { return /* binding */ useHeaderSecondNavGeo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _headerSecondNavI18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98701);
/* harmony import */ var lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85132);






/**
 * Fetches location + weather for the second nav bar.
 *
 * 1. Ask the browser for GPS (user may deny).
 * 2. If OK: call reverse geocode + weather API in parallel.
 * 3. If GPS missing: keep `fallbackLocationLabel` and leave weather empty.
 *
 * Re-runs when `resolvedLocale` changes (e.g. language switch → new geocode language).
 */ function useHeaderSecondNavGeo(param) {
    var resolvedLocale = param.resolvedLocale, fallbackLocationLabel = param.fallbackLocationLabel;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), geoBusy = ref[0], setGeoBusy = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("undetermined"), geoPermission = ref1[0], setGeoPermission = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), weatherCode = ref2[0], setWeatherCode = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        return (0,lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeDisplayText */ .Me)(fallbackLocationLabel, 120);
    }), locationLabel = ref3[0], setLocationLabel = ref3[1];
    // CMS / prop fallback text changed
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setLocationLabel((0,lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeDisplayText */ .Me)(fallbackLocationLabel, 120));
    }, [
        fallbackLocationLabel
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (typeof navigator === "undefined" || !navigator.geolocation) {
            setGeoPermission("denied");
            setGeoBusy(false);
            setWeatherCode(null);
            return;
        }
        var stillMounted = true;
        var stop = function() {
            stillMounted = false;
        };
        setGeoPermission("undetermined");
        setGeoBusy(true);
        setWeatherCode(null);
        setLocationLabel((0,lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeDisplayText */ .Me)(fallbackLocationLabel, 120));
        var finishLoading = function() {
            if (stillMounted) setGeoBusy(false);
        };
        var geoLang = (0,_headerSecondNavI18n__WEBPACK_IMPORTED_MODULE_1__.getGeocodeLanguageCode)(resolvedLocale);
        navigator.geolocation.getCurrentPosition(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(pos) {
                var _coords, latitude, longitude, ref, reverseGeocodeCity, fetchWeatherCode, ref1, city, code;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!stillMounted) return [
                                2
                            ];
                            setGeoPermission("granted");
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                4,
                                5
                            ]);
                            _coords = pos.coords, latitude = _coords.latitude, longitude = _coords.longitude;
                            if (!(0,lib_safeDisplayText__WEBPACK_IMPORTED_MODULE_2__/* .isValidCoordinates */ .OF)(latitude, longitude)) {
                                finishLoading();
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 21940))
                            ];
                        case 2:
                            ref = _state.sent(), reverseGeocodeCity = ref.reverseGeocodeCity, fetchWeatherCode = ref.fetchWeatherCode;
                            return [
                                4,
                                Promise.all([
                                    reverseGeocodeCity(latitude, longitude, geoLang),
                                    fetchWeatherCode(latitude, longitude)
                                ])
                            ];
                        case 3:
                            ref1 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"].apply */ .Z.apply(void 0, [
                                _state.sent(),
                                2
                            ]), city = ref1[0], code = ref1[1];
                            if (!stillMounted) return [
                                2
                            ];
                            if (city) setLocationLabel(city);
                            if (code !== null) setWeatherCode(code);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            finishLoading();
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(pos) {
                return _ref.apply(this, arguments);
            };
        }(), function(err) {
            if (!stillMounted) return;
            setWeatherCode(null);
            if (err.code === err.PERMISSION_DENIED) {
                setGeoPermission("denied");
            } else {
                // Timeout / unavailable: still show the row with "—" (user did not block permission)
                setGeoPermission("granted");
            }
            finishLoading();
        }, {
            enableHighAccuracy: false,
            timeout: 15000,
            maximumAge: 300000
        });
        return stop;
    // Re-fetch when locale changes (geocode language). Fallback is read on that run only.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fallback-only updates handled in a separate effect
    }, [
        resolvedLocale
    ]);
    var showGeoRows = geoPermission !== "denied";
    var geoRowsLoading = showGeoRows && geoBusy;
    return {
        geoBusy: geoBusy,
        weatherCode: weatherCode,
        locationLabel: locationLabel,
        showGeoRows: showGeoRows,
        geoRowsLoading: geoRowsLoading
    };
}


/***/ }),

/***/ 59548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _HeaderSearchPanel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53693);
/* harmony import */ var components_Shared_icons_arrow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18106);
/* harmony import */ var components_Shared_icons_search__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90505);
/* harmony import */ var components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87664);
/* harmony import */ var lib_linkExternalProps__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18693);
/* harmony import */ var lib_newWindowA11y__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(92248);
/* harmony import */ var _Components_languages_dropdown_DGA_LanguagesDropdown_DGA__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82183);
/* harmony import */ var components_Shared_dga_link_ExternalLinkTypeIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18401);
/* harmony import */ var _helpers_headerNav_DGAHelpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65361);
/* eslint-disable @typescript-eslint/no-explicit-any */ 




// import Link from 'next/link'










var DesktopNav = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
    var ref23 = props || {}, activeNavItem = ref23.activeNavItem, setActiveNavItem = ref23.setActiveNavItem, isSearchPanelOpen = ref23.isSearchPanelOpen, setIsSearchPanelOpen = ref23.setIsSearchPanelOpen, locale = ref23.locale, unSupportedLocales = ref23.unSupportedLocales, selectedHeaderNavItemsIds = ref23.selectedHeaderNavItemsIds;
    // local clicked selection state: used so a click marks an item as selected visually
    var ref24 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(null), 2), clickedItemId = ref24[0], setClickedItemId = ref24[1];
    // Clear clickedItemId when submenu closes (activeNavItem is cleared)
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        var ref, ref1;
        // If activeNavItem is empty or doesn't have SubMenuSection, clear clickedItemId
        if (!(activeNavItem === null || activeNavItem === void 0 ? void 0 : (ref = activeNavItem.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.SubMenuSection) === null || ref1 === void 0 ? void 0 : ref1.length)) {
            setClickedItemId(null);
        }
    }, [
        activeNavItem
    ]);
    var handleClickOnSearchIcon = function() {
        var ref, ref1;
        if ((activeNavItem === null || activeNavItem === void 0 ? void 0 : (ref = activeNavItem.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.SubMenuSection) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
            setActiveNavItem({});
            setIsSearchPanelOpen(true);
        } else {
            setIsSearchPanelOpen(function(prev) {
                return !prev;
            });
        }
    };
    var handleClickOnNavItem = function(menuItem) {
        var ref, ref1, ref2, ref3;
        // If clicking the same item, do nothing
        if ((activeNavItem === null || activeNavItem === void 0 ? void 0 : (ref = activeNavItem.fields) === null || ref === void 0 ? void 0 : (ref1 = ref["Link Text"]) === null || ref1 === void 0 ? void 0 : ref1.value) === (menuItem === null || menuItem === void 0 ? void 0 : (ref2 = menuItem.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2["Link Text"]) === null || ref3 === void 0 ? void 0 : ref3.value)) return;
        // Clear previous clicked item when clicking a different item
        if (clickedItemId && clickedItemId !== (menuItem === null || menuItem === void 0 ? void 0 : menuItem.id)) {
            setClickedItemId(null);
        }
        setIsSearchPanelOpen(false);
        setActiveNavItem(function() {
            var ref, ref1;
            if ((menuItem === null || menuItem === void 0 ? void 0 : (ref = menuItem.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.SubMenuSection) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
                return menuItem;
            }
        });
    };
    // const [isLangsDDLOpen, setIsLangsDDLOpen] = React.useState<boolean>(false);
    var langs = props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Languages) === null || ref1 === void 0 ? void 0 : ref1.map(function(lang) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        return {
            label: lang === null || lang === void 0 ? void 0 : (ref = lang.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Title) === null || ref1 === void 0 ? void 0 : ref1.value,
            href: lang === null || lang === void 0 ? void 0 : (ref2 = lang.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Code) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Iso) === null || ref5 === void 0 ? void 0 : ref5.value,
            unsupportedText: (lang === null || lang === void 0 ? void 0 : (ref6 = lang.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.UnsupportedText) === null || ref7 === void 0 ? void 0 : ref7.value) || ""
        };
    });
    var ref25;
    var subMenuOpen = ((ref25 = activeNavItem === null || activeNavItem === void 0 ? void 0 : (ref2 = activeNavItem.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.SubMenuSection) === null || ref3 === void 0 ? void 0 : ref3.length) !== null && ref25 !== void 0 ? ref25 : 0) > 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex min-h-[72px] items-center justify-between w-full relative z-[100] bg-white",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center gap-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: locale ? "/".concat(locale) : "/",
                                className: "flex w-[93px] h-[59px] items-center rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-[#161616] focus-visible:ring-offset-2",
                                "aria-label": (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === "ar" ? "الصفحة الرئيسية لوزارة الثقافة" : (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === "zh" ? "沙特阿拉伯文化部主页" : (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === "ko" ? "사우디아라비아 문화부 홈" : "Saudi Ministry of Culture home",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    loading: "lazy",
                                    src: "/moc_logo_light.svg",
                                    alt: "",
                                    "aria-hidden": true,
                                    width: 93,
                                    height: 60,
                                    className: "cursor-pointer w-[93px] h-[59px] min-w-[93px] min-h-[59px] object-contain"
                                })
                            }),
                            (props === null || props === void 0 ? void 0 : (ref4 = props.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Links) === null || ref5 === void 0 ? void 0 : ref5.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                                "aria-label": (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === "ar" ? "التنقل الرئيسي" : (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === "zh" ? "主导航" : (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === "ko" ? "주 메뉴" : "Primary navigation",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                    className: "flex items-center gap-2",
                                    children: props === null || props === void 0 ? void 0 : (ref6 = props.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Links) === null || ref7 === void 0 ? void 0 : ref7.map(function(menuItem) {
                                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
                                        if ((0,_helpers_headerNav_DGAHelpers__WEBPACK_IMPORTED_MODULE_10__.isHeaderNavLinkHidden)(menuItem)) {
                                            return null;
                                        }
                                        var ref16;
                                        var hasSubmenu = ((ref16 = menuItem === null || menuItem === void 0 ? void 0 : (ref = menuItem.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.SubMenuSection) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref16 !== void 0 ? ref16 : 0) > 0;
                                        var isItemSelected = selectedHeaderNavItemsIds.includes(menuItem === null || menuItem === void 0 ? void 0 : menuItem.id) || clickedItemId === (menuItem === null || menuItem === void 0 ? void 0 : menuItem.id);
                                        var isSubmenuOpen = (activeNavItem === null || activeNavItem === void 0 ? void 0 : (ref2 = activeNavItem.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2["Link Text"]) === null || ref3 === void 0 ? void 0 : ref3.value) === (menuItem === null || menuItem === void 0 ? void 0 : (ref4 = menuItem.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4["Link Text"]) === null || ref5 === void 0 ? void 0 : ref5.value);
                                        var surfaceClassName = "text-black font-medium cursor-pointer relative whitespace-nowrap rounded hover:bg-[#F3F4F6] active:bg-[#E5E7EB] text-base transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#161616] focus-visible:ring-offset-2 focus:ring-2 focus:ring-[#161616] focus:ring-offset-2 ".concat(isItemSelected ? "bg-[#1B8354] hover:!bg-[#166A45] active:!bg-[#104631] !text-white focus-visible:ring-2 focus-visible:ring-[#161616]" : "");
                                        return (hasSubmenu || (menuItem === null || menuItem === void 0 ? void 0 : (ref6 = menuItem.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Link) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.value) === null || ref8 === void 0 ? void 0 : ref8.href)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            className: "relative group",
                                            children: [
                                                hasSubmenu ? (menuItem === null || menuItem === void 0 ? void 0 : (ref9 = menuItem.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9["Link Text"]) === null || ref10 === void 0 ? void 0 : ref10.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                    type: "button",
                                                    "aria-expanded": isSubmenuOpen,
                                                    "aria-haspopup": "true",
                                                    "aria-controls": "dga-header-submenu-panel",
                                                    onClick: function() {
                                                        handleClickOnNavItem(menuItem);
                                                        var ref;
                                                        setClickedItemId((ref = menuItem === null || menuItem === void 0 ? void 0 : menuItem.id) !== null && ref !== void 0 ? ref : null);
                                                    },
                                                    className: surfaceClassName,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        className: "flex h-[72px] items-center gap-1 px-4",
                                                        children: [
                                                            menuItem === null || menuItem === void 0 ? void 0 : (ref11 = menuItem.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11["Link Text"]) === null || ref12 === void 0 ? void 0 : ref12.value,
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_icons_arrow__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                                "aria-hidden": true,
                                                                fill: isItemSelected ? "#ffffff" : "#161616",
                                                                className: "z-0 transition-transform origin-center ".concat(isSubmenuOpen ? "-rotate-180" : "rotate-0")
                                                            })
                                                        ]
                                                    })
                                                }) : (menuItem === null || menuItem === void 0 ? void 0 : (ref13 = menuItem.fields) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.Link) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.value) === null || ref15 === void 0 ? void 0 : ref15.href) && function() {
                                                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
                                                    var leafTarget = ((menuItem === null || menuItem === void 0 ? void 0 : (ref = menuItem.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Link) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.target) || "_self").trim() || "_self";
                                                    var leafBlank = (0,lib_linkExternalProps__WEBPACK_IMPORTED_MODULE_11__/* .isBlankTarget */ .S)(menuItem === null || menuItem === void 0 ? void 0 : (ref3 = menuItem.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.Link) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.target);
                                                    var leafText = ((menuItem === null || menuItem === void 0 ? void 0 : (ref6 = menuItem.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6["Link Text"]) === null || ref7 === void 0 ? void 0 : ref7.value) || "").trim();
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                                                        href: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_6__.CleanRelativeLink)(menuItem === null || menuItem === void 0 ? void 0 : (ref8 = menuItem.fields) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.Link) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.value) === null || ref10 === void 0 ? void 0 : ref10.href) || undefined,
                                                        target: leafTarget,
                                                        rel: (0,lib_linkExternalProps__WEBPACK_IMPORTED_MODULE_11__/* .relForBlankTarget */ .H)(menuItem === null || menuItem === void 0 ? void 0 : (ref11 = menuItem.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.Link) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.value) === null || ref13 === void 0 ? void 0 : ref13.target),
                                                        className: "".concat(surfaceClassName, " flex h-[72px] items-center px-4")
                                                    }, leafBlank && leafText ? {
                                                        "aria-label": (0,lib_newWindowA11y__WEBPACK_IMPORTED_MODULE_14__/* .ariaLabelWithNewWindowNotice */ .wI)(leafText, locale),
                                                        title: (0,lib_newWindowA11y__WEBPACK_IMPORTED_MODULE_14__/* .newWindowNoticeTitle */ .yB)(locale)
                                                    } : leafBlank ? {
                                                        title: (0,lib_newWindowA11y__WEBPACK_IMPORTED_MODULE_14__/* .newWindowNoticeTitle */ .yB)(locale)
                                                    } : {}), {
                                                        children: menuItem === null || menuItem === void 0 ? void 0 : (ref14 = menuItem.fields) === null || ref14 === void 0 ? void 0 : (ref15 = ref14["Link Text"]) === null || ref15 === void 0 ? void 0 : ref15.value
                                                    }));
                                                }(),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "absolute bottom-0 left-0 right-0 h-[6px] rounded-full z-30 transition-all w-[80%] mx-auto ".concat(isItemSelected ? "visible bg-[#54C08A] " : "invisible group-hover:visible group-hover:bg-[#9DA4AE] group-active:bg-[#1F2A37]")
                                                })
                                            ]
                                        }, menuItem === null || menuItem === void 0 ? void 0 : menuItem.id);
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            [
                                {
                                    title: (props === null || props === void 0 ? void 0 : (ref8 = props.locale) === null || ref8 === void 0 ? void 0 : ref8.toLowerCase()) === "en" ? "Search" : (props === null || props === void 0 ? void 0 : (ref9 = props.locale) === null || ref9 === void 0 ? void 0 : ref9.toLowerCase()) === "zh" ? "搜索" : (props === null || props === void 0 ? void 0 : (ref10 = props.locale) === null || ref10 === void 0 ? void 0 : ref10.toLowerCase()) === "ko" ? "검색" : "بحث",
                                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_icons_search__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                        color: isSearchPanelOpen ? "#FFFFFF" : "#161616",
                                        classes: "stroke-current w-5 h-5 xl:w-6 xl:h-6",
                                        "aria-hidden": true
                                    }),
                                    onClick: handleClickOnSearchIcon
                                }, 
                            ].map(function(buttonItem, index) {
                                // search and language buttons
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    type: "button",
                                    onClick: buttonItem === null || buttonItem === void 0 ? void 0 : buttonItem.onClick,
                                    className: "group relative flex h-[72px] items-center gap-1 rounded px-4 text-base font-medium transition-colors hover:bg-[#F3F4F6] active:bg-[#E5E7EB] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#161616] focus-visible:ring-offset-2 focus:ring-2 focus:ring-[#161616] focus:ring-offset-2 ".concat(isSearchPanelOpen ? "bg-[#1B8354] hover:!bg-[#166A45] active:!bg-[#104631] text-white focus-visible:ring-2 focus-visible:ring-[#161616]" : "text-black"),
                                    children: [
                                        buttonItem === null || buttonItem === void 0 ? void 0 : buttonItem.icon,
                                        buttonItem === null || buttonItem === void 0 ? void 0 : buttonItem.title,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute bottom-0 left-1/2 transform -translate-x-1/2 h-[6px] w-[86.89%] rounded-full z-30 transition-colors ".concat(isSearchPanelOpen ? "visible bg-[#54C08A]" : "invisible group-hover:visible group-hover:bg-[#9DA4AE] group-active:bg-[#1F2A37]")
                                        })
                                    ]
                                }, index);
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Components_languages_dropdown_DGA_LanguagesDropdown_DGA__WEBPACK_IMPORTED_MODULE_7__["default"], {
                                currentLocale: locale !== null && locale !== void 0 ? locale : "ar",
                                unSupportedLocales: unSupportedLocales,
                                labels: {
                                    trigger: locale === "en" ? "عربي" : locale === "zh" ? "عربي" : locale === "ko" ? "عربي" : "English",
                                    options: langs
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "dga-header-submenu-panel",
                className: subMenuOpen ? "absolute top-full left-0 right-0 flex items-center justify-start py-6 w-full bg-white rounded-b-3xl z-[98] shadow-2xl animate-slide-in" : "hidden",
                "aria-hidden": !subMenuOpen,
                children: subMenuOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "responsive pl-24 rtl:pr-24 grid gap-6 w-full",
                    style: {
                        gridTemplateColumns: "repeat(".concat(((ref13 = activeNavItem === null || activeNavItem === void 0 ? void 0 : (ref11 = activeNavItem.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.SubMenuSection) === null || ref12 === void 0 ? void 0 : ref12.filter(function(item) {
                            return !(0,_helpers_headerNav_DGAHelpers__WEBPACK_IMPORTED_MODULE_10__.isHeaderNavLinkHidden)(item);
                        })) === null || ref13 === void 0 ? void 0 : ref13.length) || 1, ", min-content)")
                    },
                    children: activeNavItem === null || activeNavItem === void 0 ? void 0 : (ref14 = activeNavItem.fields) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.SubMenuSection) === null || ref15 === void 0 ? void 0 : ref15.map(function(subItem) {
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26;
                        if ((0,_helpers_headerNav_DGAHelpers__WEBPACK_IMPORTED_MODULE_10__.isHeaderNavLinkHidden)(subItem)) {
                            return null;
                        }
                        var visibleInnerItems = (subItem === null || subItem === void 0 ? void 0 : (ref = subItem.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.InnerMenuSection) === null || ref1 === void 0 ? void 0 : ref1.filter(function(child) {
                            return !(0,_helpers_headerNav_DGAHelpers__WEBPACK_IMPORTED_MODULE_10__.isHeaderNavLinkHidden)(child);
                        })) || [];
                        return visibleInnerItems.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "py-2 flex flex-col items-start gap-3 min-w-[154px] overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-primary-800 px-3 xl:px-4 font-bold text-base xl:text-lg whitespace-nowrap",
                                    children: subItem === null || subItem === void 0 ? void 0 : (ref2 = subItem.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2["Link Text"]) === null || ref3 === void 0 ? void 0 : ref3.value
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                    className: "flex flex-col items-start gap-1",
                                    children: visibleInnerItems.map(function(childSubItem) {
                                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "rounded-lg w-full font-medium text-sm xl:text-base whitespace-nowrap hover:bg-neutral-100 hover:underline transition-colors",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                href: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_6__.CleanRelativeLink)(childSubItem === null || childSubItem === void 0 ? void 0 : (ref = childSubItem.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Link) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.href) + ((childSubItem === null || childSubItem === void 0 ? void 0 : (ref3 = childSubItem.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.Link) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.querystring) && (childSubItem === null || childSubItem === void 0 ? void 0 : (ref6 = childSubItem.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Link) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.value) === null || ref8 === void 0 ? void 0 : ref8.querystring) !== "undefined" && (childSubItem === null || childSubItem === void 0 ? void 0 : (ref9 = childSubItem.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.Link) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.value) === null || ref11 === void 0 ? void 0 : ref11.querystring) !== "null" ? childSubItem === null || childSubItem === void 0 ? void 0 : (ref12 = childSubItem.fields) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.Link) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.value) === null || ref14 === void 0 ? void 0 : ref14.querystring : ""),
                                                target: (childSubItem === null || childSubItem === void 0 ? void 0 : (ref15 = childSubItem.fields) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.Link) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.value) === null || ref17 === void 0 ? void 0 : ref17.target) || "_self",
                                                className: "py-2 px-3 xl:px-4 w-full flex gap-1 items-center",
                                                children: [
                                                    childSubItem === null || childSubItem === void 0 ? void 0 : (ref18 = childSubItem.fields) === null || ref18 === void 0 ? void 0 : (ref19 = ref18["Link Text"]) === null || ref19 === void 0 ? void 0 : ref19.value,
                                                    " ",
                                                    (childSubItem === null || childSubItem === void 0 ? void 0 : (ref20 = childSubItem.fields) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.Link) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.value) === null || ref22 === void 0 ? void 0 : ref22.linktype) === "external" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_link_ExternalLinkTypeIcon__WEBPACK_IMPORTED_MODULE_8__.ExternalLinkTypeIcon, {})
                                                    })
                                                ]
                                            })
                                        }, childSubItem === null || childSubItem === void 0 ? void 0 : childSubItem.id);
                                    })
                                })
                            ]
                        }, subItem === null || subItem === void 0 ? void 0 : subItem.id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_6__.CleanRelativeLink)(subItem === null || subItem === void 0 ? void 0 : (ref4 = subItem.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Link) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.value) === null || ref6 === void 0 ? void 0 : ref6.href) + ((subItem === null || subItem === void 0 ? void 0 : (ref7 = subItem.fields) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.Link) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.value) === null || ref9 === void 0 ? void 0 : ref9.querystring) && (subItem === null || subItem === void 0 ? void 0 : (ref10 = subItem.fields) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.Link) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.value) === null || ref12 === void 0 ? void 0 : ref12.querystring) !== "undefined" && (subItem === null || subItem === void 0 ? void 0 : (ref13 = subItem.fields) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.Link) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.value) === null || ref15 === void 0 ? void 0 : ref15.querystring) !== "null" ? subItem === null || subItem === void 0 ? void 0 : (ref16 = subItem.fields) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.Link) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.value) === null || ref18 === void 0 ? void 0 : ref18.querystring : ""),
                            target: (subItem === null || subItem === void 0 ? void 0 : (ref19 = subItem.fields) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.Link) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.value) === null || ref21 === void 0 ? void 0 : ref21.target) || "_self",
                            className: "flex gap-1 items-center rounded-lg py-2 px-3 xl:px-4 min-w-[154px] w-full h-fit font-medium text-sm xl:text-base whitespace-nowrap hover:bg-neutral-100 hover:underline transition-colors",
                            children: [
                                subItem === null || subItem === void 0 ? void 0 : (ref22 = subItem.fields) === null || ref22 === void 0 ? void 0 : (ref23 = ref22["Link Text"]) === null || ref23 === void 0 ? void 0 : ref23.value,
                                " ",
                                (subItem === null || subItem === void 0 ? void 0 : (ref24 = subItem.fields) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.Link) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.value) === null || ref26 === void 0 ? void 0 : ref26.linktype) === "external" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_link_ExternalLinkTypeIcon__WEBPACK_IMPORTED_MODULE_8__.ExternalLinkTypeIcon, {})
                                })
                            ]
                        }, subItem === null || subItem === void 0 ? void 0 : subItem.id);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeaderSearchPanel__WEBPACK_IMPORTED_MODULE_3__["default"], {
                SearchButtonText: props === null || props === void 0 ? void 0 : (ref16 = props.fields) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.SearchButtonText) === null || ref17 === void 0 ? void 0 : ref17.value,
                SearchInputPlaceholder: props === null || props === void 0 ? void 0 : (ref18 = props.fields) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.SearchInputPlaceholder) === null || ref19 === void 0 ? void 0 : ref19.value,
                SuggestionsHeader: props === null || props === void 0 ? void 0 : (ref20 = props.fields) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.SuggestionsHeader) === null || ref21 === void 0 ? void 0 : ref21.value,
                SuggestionItems: props === null || props === void 0 ? void 0 : (ref22 = props.fields) === null || ref22 === void 0 ? void 0 : ref22.SuggestionItems,
                isSearchPanelOpen: !subMenuOpen && isSearchPanelOpen,
                setIsSearchPanelOpen: setIsSearchPanelOpen,
                locale: props === null || props === void 0 ? void 0 : props.locale
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (DesktopNav);


/***/ }),

/***/ 68273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_Shared_accordion_MobileNavAccordionItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88176);
/* harmony import */ var components_Shared_icons_close__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51430);
/* harmony import */ var components_Shared_icons_search__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90505);
/* harmony import */ var components_Shared_icons_burger_menu__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9517);
/* harmony import */ var _HeaderSearchPanel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53693);
/* harmony import */ var _Components_languages_dropdown_DGA_LanguagesDropdown_DGA__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82183);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ 










var MobileNav = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = props || {}, fields = ref10.fields, locale = ref10.locale, isSearchPanelOpen = ref10.isSearchPanelOpen, setIsSearchPanelOpen = ref10.setIsSearchPanelOpen, unSupportedLocales = ref10.unSupportedLocales;
    var ref11 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), isMobileNavOpen = ref11[0], setMobileNavOpen = ref11[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var originalOverflow = document.body.style.overflow;
        if (typeof document === "undefined") return;
        if (isMobileNavOpen) {
            document.body.style.overflow = "hidden";
            document.body.style.scrollbarGutter = "stable";
            document.body.style.height = "100vh";
        } else {
            document.body.style.overflow = originalOverflow;
            document.body.style.scrollbarGutter = "auto";
            document.body.style.height = "auto";
        }
        return function() {
            document.body.style.overflow = originalOverflow;
            document.body.style.scrollbarGutter = "auto";
            document.body.style.height = "auto";
        };
    }, [
        isMobileNavOpen
    ]);
    var handleClickOnSearchIcon = function() {
        // Close mobile nav first, then toggle search panel
        if (isMobileNavOpen) {
            setMobileNavOpen(false);
        }
        setIsSearchPanelOpen(function(prev) {
            return !prev;
        });
    };
    var handleMobileNavToggle = function() {
        // Close search panel first, then toggle mobile nav
        if (isSearchPanelOpen) {
            setIsSearchPanelOpen(false);
        }
        setMobileNavOpen(function(prev) {
            return !prev;
        });
    };
    // Ensure mutual exclusivity: when search panel opens, close mobile nav
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isSearchPanelOpen && isMobileNavOpen) {
            setMobileNavOpen(false);
        }
    }, [
        isSearchPanelOpen,
        isMobileNavOpen
    ]);
    // Ensure mutual exclusivity: when mobile nav opens, close search panel
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isMobileNavOpen && isSearchPanelOpen) {
            setIsSearchPanelOpen(false);
        }
    }, [
        isMobileNavOpen,
        isSearchPanelOpen,
        setIsSearchPanelOpen
    ]);
    var langs = props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Languages) === null || ref1 === void 0 ? void 0 : ref1.map(function(lang) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        return {
            label: lang === null || lang === void 0 ? void 0 : (ref = lang.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Title) === null || ref1 === void 0 ? void 0 : ref1.value,
            href: lang === null || lang === void 0 ? void 0 : (ref2 = lang.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Code) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Iso) === null || ref5 === void 0 ? void 0 : ref5.value
        };
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center justify-between gap-4 py-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: "/",
                        locale: locale,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "inline-flex rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-[#161616] focus-visible:ring-offset-2",
                            "aria-label": (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === "ar" ? "الصفحة الرئيسية لوزارة الثقافة" : (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === "zh" ? "沙特阿拉伯文化部主页" : (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === "ko" ? "사우디아라비아 문화부 홈" : "Saudi Ministry of Culture home",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                loading: "eager",
                                priority: true,
                                src: "/moc_logo_light.svg",
                                alt: "",
                                "aria-hidden": true,
                                width: 93,
                                height: 60,
                                className: "cursor-pointer min-w-[93px] min-h-[60px]"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: handleMobileNavToggle,
                        "aria-label": isMobileNavOpen ? "Close navigation menu" : "Open navigation menu",
                        "aria-expanded": isMobileNavOpen,
                        className: "flex items-center justify-center bg-neutral-100 hover:bg-neutral-200 active:bg-neutral-300 rounded p-[6px] transition-colors",
                        children: isMobileNavOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_icons_close__WEBPACK_IMPORTED_MODULE_5__["default"], {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_icons_burger_menu__WEBPACK_IMPORTED_MODULE_7__["default"], {})
                    })
                ]
            }),
            isMobileNavOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute top-full h-[80vh] pb-28 left-0 right-0 pt-4  overflow-auto bg-[white] z-[9999]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-[95%] mx-auto bg-[white] w-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                            "aria-label": (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === "ar" ? "التنقل الرئيسي" : (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === "zh" ? "主导航" : (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === "ko" ? "주 메뉴" : "Primary navigation",
                            className: "bg-[white]",
                            children: fields === null || fields === void 0 ? void 0 : (ref2 = fields.Links) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
                                var ref;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_accordion_MobileNavAccordionItem__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                    selected: props === null || props === void 0 ? void 0 : (ref = props.selectedHeaderNavItemsIds) === null || ref === void 0 ? void 0 : ref.includes(item.id),
                                    item: item
                                }, item.id);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col items-start w-full mt-16",
                            children: [
                                [
                                    {
                                        title: (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === "en" ? "Search" : (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === "zh" ? "搜索" : (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === "ko" ? "검색" : "بحث",
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_icons_search__WEBPACK_IMPORTED_MODULE_6__["default"], {
                                            color: "#161616",
                                            classes: "stroke-[#161616] w-4 h-4",
                                            "aria-hidden": true
                                        }),
                                        activeButtonClasses: "!bg-primary-600 text-white",
                                        activeHoverElementClasses: "visible !bg-primary-400",
                                        onClick: handleClickOnSearchIcon
                                    }, 
                                ].map(function(buttonItem, index) {
                                    // search and language buttons
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        type: "button",
                                        onClick: buttonItem === null || buttonItem === void 0 ? void 0 : buttonItem.onClick,
                                        className: "w-full relative text-sm font-semibold px-4 py-2 flex items-center gap-2 mobile-nav-main-item-active",
                                        children: [
                                            buttonItem === null || buttonItem === void 0 ? void 0 : buttonItem.icon,
                                            buttonItem === null || buttonItem === void 0 ? void 0 : buttonItem.title
                                        ]
                                    }, index);
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Components_languages_dropdown_DGA_LanguagesDropdown_DGA__WEBPACK_IMPORTED_MODULE_9__["default"], {
                                    currentLocale: locale !== null && locale !== void 0 ? locale : "ar",
                                    unSupportedLocales: unSupportedLocales !== null && unSupportedLocales !== void 0 ? unSupportedLocales : [],
                                    labels: {
                                        trigger: locale === "en" ? "English" : locale === "zh" ? "Chinese" : locale === "ko" ? "Korean" : "Arabic",
                                        options: langs !== null && langs !== void 0 ? langs : []
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeaderSearchPanel__WEBPACK_IMPORTED_MODULE_8__["default"], {
                SearchButtonText: props === null || props === void 0 ? void 0 : (ref3 = props.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.SearchButtonText) === null || ref4 === void 0 ? void 0 : ref4.value,
                SearchInputPlaceholder: props === null || props === void 0 ? void 0 : (ref5 = props.fields) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.SearchInputPlaceholder) === null || ref6 === void 0 ? void 0 : ref6.value,
                SuggestionsHeader: props === null || props === void 0 ? void 0 : (ref7 = props.fields) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.SuggestionsHeader) === null || ref8 === void 0 ? void 0 : ref8.value,
                SuggestionItems: props === null || props === void 0 ? void 0 : (ref9 = props.fields) === null || ref9 === void 0 ? void 0 : ref9.SuggestionItems,
                isSearchPanelOpen: isSearchPanelOpen && !isMobileNavOpen,
                setIsSearchPanelOpen: setIsSearchPanelOpen,
                locale: props === null || props === void 0 ? void 0 : props.locale
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MobileNav);


/***/ }),

/***/ 65361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "findHeaderNavItemMatch": function() { return /* binding */ findHeaderNavItemMatch; },
/* harmony export */   "isHeaderNavLinkHidden": function() { return /* binding */ isHeaderNavLinkHidden; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
/** Sitecore checkbox may arrive as boolean true, "1", or 1. */ 
var isHeaderNavLinkHidden = function(item) {
    var ref, ref1, ref2, ref3;
    var ref4;
    var value = (ref4 = item === null || item === void 0 ? void 0 : (ref = item.fields) === null || ref === void 0 ? void 0 : (ref1 = ref["Hide Link"]) === null || ref1 === void 0 ? void 0 : ref1.value) !== null && ref4 !== void 0 ? ref4 : item === null || item === void 0 ? void 0 : (ref2 = item.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.HideLink) === null || ref3 === void 0 ? void 0 : ref3.value;
    return value === true || value === "1" || value === 1 || value === "true";
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var findHeaderNavItemMatch = function(links, target) {
    var matchedIds = [];
    // Normalize target: remove protocol+domain and lowercase
    var cleanTarget = target.replace(/^https?:\/\/[^\/]+/, "").toLowerCase();
    var isExactMatch = function(url, query) {
        if (!url) return false;
        // Combine href + querystring
        var combinedUrl = url;
        if (query) {
            combinedUrl += query.startsWith("?") ? query : "?".concat(query);
        }
        // Normalize combined url like target
        var cleanUrl = combinedUrl.replace(/^https?:\/\/[^\/]+/, "").toLowerCase();
        // Exact match check
        return cleanUrl === cleanTarget;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var traverseMenu = function(item, parentId) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        // Check the current item's link
        var href = item === null || item === void 0 ? void 0 : (ref = item.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Link) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.href;
        var query = item === null || item === void 0 ? void 0 : (ref3 = item.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.Link) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.querystring;
        if (href && isExactMatch(href, query)) {
            matchedIds.push(parentId);
        }
        // Traverse SubMenuSection
        if (Array.isArray(item === null || item === void 0 ? void 0 : (ref6 = item.fields) === null || ref6 === void 0 ? void 0 : ref6.SubMenuSection)) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = item.fields.SubMenuSection[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var subItem = _step.value;
                    var ref7, ref8, ref9, ref10, ref11, ref12, ref13;
                    // Check subItem's link
                    var subHref = subItem === null || subItem === void 0 ? void 0 : (ref7 = subItem.fields) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.Link) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.value) === null || ref9 === void 0 ? void 0 : ref9.href;
                    var subQuery = subItem === null || subItem === void 0 ? void 0 : (ref10 = subItem.fields) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.Link) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.value) === null || ref12 === void 0 ? void 0 : ref12.querystring;
                    if (subHref && isExactMatch(subHref, subQuery)) {
                        matchedIds.push(parentId);
                    }
                    // Traverse InnerMenuSection
                    if (Array.isArray(subItem === null || subItem === void 0 ? void 0 : (ref13 = subItem.fields) === null || ref13 === void 0 ? void 0 : ref13.InnerMenuSection)) {
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = subItem.fields.InnerMenuSection[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var innerItem = _step1.value;
                                var ref14, ref15, ref16, ref17, ref18, ref19, ref20;
                                var innerHref = innerItem === null || innerItem === void 0 ? void 0 : (ref14 = innerItem.fields) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.Link) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.value) === null || ref16 === void 0 ? void 0 : ref16.href;
                                var innerQuery = innerItem === null || innerItem === void 0 ? void 0 : (ref17 = innerItem.fields) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.Link) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.value) === null || ref19 === void 0 ? void 0 : ref19.querystring;
                                if (innerHref && isExactMatch(innerHref, innerQuery)) {
                                    matchedIds.push(parentId);
                                }
                                // Handle deeper nested InnerMenuSection if exists
                                if (Array.isArray(innerItem === null || innerItem === void 0 ? void 0 : (ref20 = innerItem.fields) === null || ref20 === void 0 ? void 0 : ref20.InnerMenuSection)) {
                                    traverseMenu(innerItem, parentId); // Recursive call for deeper nesting
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = links[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var link = _step.value;
            traverseMenu(link, link.id);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Remove duplicates and return unique IDs
    return target === "/" ? [] : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Set(matchedIds));
};


/***/ }),

/***/ 53693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16606);
/* harmony import */ var components_Shared_icons_cancel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11776);
/* harmony import */ var components_Shared_icons_search__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90505);
/* harmony import */ var components_Shared_icons_LoadingSpinner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2576);
/* harmony import */ var components_Shared_DGA_inputs_DGA_input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(130);
/* harmony import */ var components_Shared_icons_close__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51430);
/* harmony import */ var components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63651);
/* harmony import */ var components_Shared_icons_plus__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43807);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_10__);






// import Plus from 'components/Shared/icons/plus';








var HeaderSearchPanel = function(param) {
    var SearchButtonText = param.SearchButtonText, SearchInputPlaceholder = param.SearchInputPlaceholder, SuggestionsHeader = param.SuggestionsHeader, SuggestionItems = param.SuggestionItems, isSearchPanelOpen = param.isSearchPanelOpen, setIsSearchPanelOpen = param.setIsSearchPanelOpen, locale = param.locale;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), search = ref[0], setSearch = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), apiSuggestions = ref1[0], setApiSuggestions = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoadingSuggestions = ref2[0], setIsLoadingSuggestions = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isRouteLoading = ref3[0], setIsRouteLoading = ref3[1];
    var debounceTimerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // Fetch search suggestions from API
    var fetchSearchSuggestions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(searchTerm) {
            var ref, response, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!searchTerm || searchTerm.trim().length < 2) {
                            setApiSuggestions([]);
                            return [
                                2
                            ];
                        }
                        setIsLoadingSuggestions(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_10___default().post("".concat("https://c-admin.takamulstg.com", "/api/Search/GetAll"), {
                                culture: locale || "en",
                                PageNumber: 0,
                                PageSize: 15,
                                order: "",
                                search: searchTerm
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if ((ref = response.data) === null || ref === void 0 ? void 0 : ref.AwardsMediaCenter) {
                            setApiSuggestions(response.data.AwardsMediaCenter);
                        } else {
                            setApiSuggestions([]);
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Error fetching search suggestions:", error);
                        setApiSuggestions([]);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsLoadingSuggestions(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(searchTerm) {
            return _ref.apply(this, arguments);
        };
    }(), [
        locale
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleStart = function() {
            return setIsRouteLoading(true);
        };
        var handleEnd = function() {
            return setIsRouteLoading(false);
        };
        next_router__WEBPACK_IMPORTED_MODULE_2__.Router.events.on("routeChangeStart", handleStart);
        next_router__WEBPACK_IMPORTED_MODULE_2__.Router.events.on("routeChangeComplete", handleEnd);
        next_router__WEBPACK_IMPORTED_MODULE_2__.Router.events.on("routeChangeError", handleEnd);
        return function() {
            next_router__WEBPACK_IMPORTED_MODULE_2__.Router.events.off("routeChangeStart", handleStart);
            next_router__WEBPACK_IMPORTED_MODULE_2__.Router.events.off("routeChangeComplete", handleEnd);
            next_router__WEBPACK_IMPORTED_MODULE_2__.Router.events.off("routeChangeError", handleEnd);
            setIsSearchPanelOpen(false);
        };
    }, []);
    // Cleanup debounce timer on unmount
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return function() {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
        };
    }, []);
    // Reset suggestions when panel closes
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isSearchPanelOpen) {
            setSearch("");
            setApiSuggestions([]);
        }
    }, [
        isSearchPanelOpen
    ]);
    if (!isSearchPanelOpen) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    // Debounced search handler
    var handleSearchChange = function(value) {
        setSearch(value);
        // Clear previous timer
        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }
        // Set new timer for debounced API call
        debounceTimerRef.current = setTimeout(function() {
            fetchSearchSuggestions(value);
        }, 300); // 300ms debounce
    };
    var handleSearchFormSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(e) {
            var formData, searchInput, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        formData = new FormData(e.currentTarget);
                        searchInput = formData.get("searchInput");
                        if (!searchInput) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            router.push({
                                pathname: "/modules/pages/search-results",
                                query: {
                                    search: searchInput
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        setIsSearchPanelOpen(false);
                        _state.label = 3;
                    case 3:
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSearchFormSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSuggestionClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(suggestionValue) {
            var error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSearch(suggestionValue);
                        setApiSuggestions([]);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        if (!suggestionValue) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            router.push({
                                pathname: "/modules/pages/search-results",
                                query: {
                                    search: suggestionValue
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        setIsSearchPanelOpen(false);
                        _state.label = 3;
                    case 3:
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSuggestionClick(suggestionValue) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "absolute top-full left-0 right-0 w-full bg-white py-8 rounded-b-3xl z-[99] animate-slide-in shadow-2xl",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "responsive flex flex-col items-start gap-6 lg:gap-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    onClick: function() {
                        return setIsSearchPanelOpen(false);
                    },
                    className: "flex items-center justify-center w-fit self-end p-[6px] hover:!bg-[#F6F4F3] transition-colors duration-300 rounded",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_icons_cancel__WEBPACK_IMPORTED_MODULE_3__["default"], {
                        color: "#161616",
                        className: "w-6 h-6"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                    onSubmit: handleSearchFormSubmit,
                    className: "flex items-center gap-4 w-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative flex-1",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_DGA_inputs_DGA_input__WEBPACK_IMPORTED_MODULE_6__["default"], {
                                    type: "text",
                                    name: "searchInput",
                                    placeholder: SearchInputPlaceholder,
                                    InputSize: "lg",
                                    value: search,
                                    onChange: function(e) {
                                        return handleSearchChange(e.target.value);
                                    },
                                    startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        type: "submit",
                                        disabled: isRouteLoading,
                                        "aria-label": SearchButtonText || "Search",
                                        className: "disabled:opacity-60 disabled:cursor-not-allowed",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_icons_search__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                            color: "#161616",
                                            classes: "w-5 h-5 cursor-pointer",
                                            "aria-hidden": true
                                        })
                                    }),
                                    endIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        type: "button",
                                        "aria-label": "Clear search",
                                        className: "transition-all ".concat(search ? "block opacity-100" : "opacity-0 hidden"),
                                        onClick: function() {
                                            setSearch("");
                                            setApiSuggestions([]);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_icons_close__WEBPACK_IMPORTED_MODULE_7__["default"], {
                                            "aria-hidden": true
                                        })
                                    })
                                }),
                                search && (isLoadingSuggestions || apiSuggestions.length > 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "absolute top-full left-0 right-0 mt-1 bg-white rounded-md shadow-lg z-50 max-h-[350px] overflow-y-auto",
                                    children: [
                                        isLoadingSuggestions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex items-center justify-center gap-2 px-4 py-3 text-neutral-500",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_icons_LoadingSpinner__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                                className: "!w-4 !h-4"
                                            })
                                        }),
                                        !isLoadingSuggestions && apiSuggestions.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "py-2",
                                            children: apiSuggestions.map(function(item, index) {
                                                // Extract the last part after "/" from itemPath
                                                // const getPageName = (itemPath: string) => {
                                                //     if (!itemPath) return '';
                                                //     const parts = itemPath.split('/').filter(part => part);
                                                //     return parts.length > 0 ? parts[parts.length - 1] : '';
                                                // };
                                                // const pageName = getPageName(item?.itemPath || '');
                                                // const displayTitle = pageName ? `${item?.title || ''} - ${pageName}` : item?.title || '';
                                                var displayTitle = (item === null || item === void 0 ? void 0 : item.title) || "";
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                    onClick: function() {
                                                        return handleSuggestionClick((item === null || item === void 0 ? void 0 : item.title) || "");
                                                    },
                                                    className: "w-full text-start px-4 py-2 hover:bg-neutral-100 transition-colors flex flex-col gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "text-primary-1000 font-medium text-sm",
                                                            children: displayTitle
                                                        }),
                                                        (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_13__/* .RichText */ .H, {
                                                            field: {
                                                                value: item.description
                                                            },
                                                            className: "text-neutral-600 text-xs line-clamp-2"
                                                        })
                                                    ]
                                                }, (item === null || item === void 0 ? void 0 : item.itemId) || index);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        SearchButtonText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_8__.DGAButton, {
                            type: "submit",
                            variant: "primary",
                            size: "lg",
                            className: "self-end !ring-0",
                            buttonContent: isRouteLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_icons_LoadingSpinner__WEBPACK_IMPORTED_MODULE_5__["default"], {}) : SearchButtonText,
                            disabled: isRouteLoading
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col items-start gap-4 w-full",
                    children: [
                        SuggestionsHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-primary-600 font-semibold text-lg",
                            children: SuggestionsHeader
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center flex-wrap gap-2",
                            children: SuggestionItems.map(function(item) {
                                var ref, ref1;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_8__.DGAButton, {
                                    variant: "secondarySolid",
                                    size: "md",
                                    className: "flex items-center gap-1",
                                    onClick: function() {
                                        var ref, ref1;
                                        return handleSuggestionClick(item === null || item === void 0 ? void 0 : (ref = item.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Message) === null || ref1 === void 0 ? void 0 : ref1.value);
                                    },
                                    buttonContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_icons_plus__WEBPACK_IMPORTED_MODULE_9__["default"], {
                                                "aria-label": "",
                                                "aria-hidden": true
                                            }),
                                            item === null || item === void 0 ? void 0 : (ref = item.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Message) === null || ref1 === void 0 ? void 0 : ref1.value
                                        ]
                                    })
                                }, item.id);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(HeaderSearchPanel));


/***/ })

}]);